//main chat app wrapper
(function(d, p, $, Firebase) {
    //"use strict";

    p.options = {
        widget_id: p.widget ? p.widget : p.$('#swaychat').data('widget-id'),
        org_id: p.org ? p.org : p.$('#swaychat').data('org-id'),
        api: (p.api ? '//' + p.api : 'https://api') + '.swayio.com',
        fb_url: 'https://' + (p.fb ? p.fb : 'swaychat') + '.firebaseio.com'
    };

    var live = (p.assets.indexOf('//cdn.swaychat.com') !== -1);

    // Bugsnag.apiKey = 'a986cf6864a490deb1bb50ed87fb42b5';
    // Bugsnag.appVersion = p.pkg.version;
    // Bugsnag.releaseStage = live ? 'production' : 'development';
    // Bugsnag.notifyReleaseStages = ['production'];
    // Bugsnag.autoNotify = false;
    // Bugsnag.metaData = p.options;

    function App() {
        try {

            var pkg = p.pkg;
            var api = p.options.api;
            var cdn = p.assets;
            var fb_url = p.options.fb_url;
            var org_id = p.options.org_id;
            var widget_id = p.options.widget_id;
            var uploadcare_alias_host = 'files.swaychat.com';
            var isPopOut = (location.href.indexOf(cdn + 'html/chat.html') >= 0);
            var fb_time = Firebase.ServerValue.TIMESTAMP;
            var is_loaded;
            var teams_m = {};
            var orgIntegrations, hasIntegrations = false;
            var chat;
            var hide = sc('hide');
            var ref = {};
            var t = {};
            var ui = {};
            var meta = {};
            var page_count = 0;

            var fb, visitor, session, social, pop_timer, lastnotify, preload;
            var _NotifyService, _RoundRobin, _Integrations;
            var init_timer;
            var started;
            var tried = 0;
            var hasWebSocket = 'WebSocket' in window || 'MozWebSocket' in window;
            var retry_delay = 1000 * 10;
            var def_lang = {
                are_you_sure : 'Are you sure you want to end this chat?',
                today: 'Today',
                disable_sound : 'Disable Sound',
                enable_sound: 'Enable Sound',
                attach_file: 'Attach File',
                end_chat: 'End Chat',
                submit: 'Submit',
                cancel: 'Cancel',
                leave_comment: 'Leave a comment...',
                how_did_we_do: 'How did we do?',
                send_chat_transcript_to: 'Send chat transcript to',
                transcript_sent_to: 'Transcript sent to',
                error_sending_to: 'Error sending to',
                enter_email_address: 'Enter Email Address',
                loading: 'Loading ...',
                please_wait: 'Please wait.'
            }

            // load modules here
            var retain = [
              'state',
              'uid',
              'token',
              'sid',
              'view_state',
            ];
            
            var storage = lsTest();
            
            function lsTest() {
              var test = 'test';
              try {
                localStorage.setItem(test, test);
                localStorage.removeItem(test);
                return true;
              } catch (e) {
                return false;
              }
            }
            
            //frame Storage Class
            var frameStorage = function (k, onready) {
              if (onready) {
                this.onready = onready;
              }
            
              this.k = k;
              this.state = 0;
              this.data = {};
              this.init();
            };
            
            frameStorage.prototype = {
              init: function () {
                var self = this;
                var src = cdn + 'html/storage.html';
            
                //initialize iframe
                this.f = document.createElement('iframe');
                this.f.src = src;
            
                //    this.f.onload = function () { self.ready() };
                this.f.style.display = 'none';
                document.body.appendChild(this.f);
            
                this.on(window, 'message', function (e) {self.message(e);}, false);
            
              },
            
              on: function (el, evt, fn, bubble) {
            
                if ('addEventListener' in el) {
                  el.addEventListener(evt, fn, bubble);
                } else if ('attachEvent' in el) {
                  el.attachEvent('on' + evt, fn);
                } else return;
            
              },
            
              message: function (e) {
                if (e.origin.indexOf('swaychat.com') < 0) {
                  return;
                }
            
                if (!e.data
                    || typeof e.data != 'string'
                    || /swaychat_storage/.test(e.data) == false
                    ) return;
            
                var s = JSON.parse(e.data);
            
                if (s && s.storage) {
                  switch (s.storage) {
                    case 'ready':
                      this.post('sync', { key:this.k });
                      break;
                    case 'sync':
                      this.data = s.data;
                      this.ready();
                      break;
                  }
                }
            
              },
            
              ready: function () {
                this.state = 1;
            
                //notify storage user
                if (this.onready) {
                  this.onready();
                }
              },
            
              post: function (m, a) {
                var f = this.f.contentWindow;
                var d = { storage:m, swaychat_storage:true };
                if (a) d.data = a;
                if (f)
                    f.postMessage(JSON.stringify(d), '*');
                // else
                //     Bugsnag.notify('frameStorage','fail',this);
              },
            
              save: function (k, v) {
            
                this.data[k] = v;
            
                //limit data storage on private mode browsers
                if (!storage && retain.indexOf(k) < 0) {
                  return;
                }
            
                this.post('save', { key:k, value:v });
              },
            
              del: function (k) {
                this.post('del', { key:k });
              },
            };
            
            //plugin Storage Class
            
            var Storage = function (o, fs) {
              this.fs = fs;
              if (typeof o === 'string') {
                this.key = o;
              } else {
                return false;
              }
            
              this.get();
            };
            
            Storage.prototype = {
              set: function (v) {
                this.value = v;
                this.fs.save(this.key, v);
              },
            
              get: function () {
                this.value = (this.fs.data[this.key] ? this.fs.data[this.key] : false);
                return this.value;
              },
            
              save: function () {
                this.set(this.value);
              },
            
              del: function () {
                delete this.fs.data[this.key];
                this.fs.del(this.key);
                this.value = null;
              },
            };
            

            
            function md5cycle(x, k) {
              var a = x[0];
              var b = x[1];
              var c = x[2];
              var d = x[3];
            
              a = ff(a, b, c, d, k[0], 7, -680876936);
              d = ff(d, a, b, c, k[1], 12, -389564586);
              c = ff(c, d, a, b, k[2], 17,  606105819);
              b = ff(b, c, d, a, k[3], 22, -1044525330);
              a = ff(a, b, c, d, k[4], 7, -176418897);
              d = ff(d, a, b, c, k[5], 12,  1200080426);
              c = ff(c, d, a, b, k[6], 17, -1473231341);
              b = ff(b, c, d, a, k[7], 22, -45705983);
              a = ff(a, b, c, d, k[8], 7,  1770035416);
              d = ff(d, a, b, c, k[9], 12, -1958414417);
              c = ff(c, d, a, b, k[10], 17, -42063);
              b = ff(b, c, d, a, k[11], 22, -1990404162);
              a = ff(a, b, c, d, k[12], 7,  1804603682);
              d = ff(d, a, b, c, k[13], 12, -40341101);
              c = ff(c, d, a, b, k[14], 17, -1502002290);
              b = ff(b, c, d, a, k[15], 22,  1236535329);
            
              a = gg(a, b, c, d, k[1], 5, -165796510);
              d = gg(d, a, b, c, k[6], 9, -1069501632);
              c = gg(c, d, a, b, k[11], 14,  643717713);
              b = gg(b, c, d, a, k[0], 20, -373897302);
              a = gg(a, b, c, d, k[5], 5, -701558691);
              d = gg(d, a, b, c, k[10], 9,  38016083);
              c = gg(c, d, a, b, k[15], 14, -660478335);
              b = gg(b, c, d, a, k[4], 20, -405537848);
              a = gg(a, b, c, d, k[9], 5,  568446438);
              d = gg(d, a, b, c, k[14], 9, -1019803690);
              c = gg(c, d, a, b, k[3], 14, -187363961);
              b = gg(b, c, d, a, k[8], 20,  1163531501);
              a = gg(a, b, c, d, k[13], 5, -1444681467);
              d = gg(d, a, b, c, k[2], 9, -51403784);
              c = gg(c, d, a, b, k[7], 14,  1735328473);
              b = gg(b, c, d, a, k[12], 20, -1926607734);
            
              a = hh(a, b, c, d, k[5], 4, -378558);
              d = hh(d, a, b, c, k[8], 11, -2022574463);
              c = hh(c, d, a, b, k[11], 16,  1839030562);
              b = hh(b, c, d, a, k[14], 23, -35309556);
              a = hh(a, b, c, d, k[1], 4, -1530992060);
              d = hh(d, a, b, c, k[4], 11,  1272893353);
              c = hh(c, d, a, b, k[7], 16, -155497632);
              b = hh(b, c, d, a, k[10], 23, -1094730640);
              a = hh(a, b, c, d, k[13], 4,  681279174);
              d = hh(d, a, b, c, k[0], 11, -358537222);
              c = hh(c, d, a, b, k[3], 16, -722521979);
              b = hh(b, c, d, a, k[6], 23,  76029189);
              a = hh(a, b, c, d, k[9], 4, -640364487);
              d = hh(d, a, b, c, k[12], 11, -421815835);
              c = hh(c, d, a, b, k[15], 16,  530742520);
              b = hh(b, c, d, a, k[2], 23, -995338651);
            
              a = ii(a, b, c, d, k[0], 6, -198630844);
              d = ii(d, a, b, c, k[7], 10,  1126891415);
              c = ii(c, d, a, b, k[14], 15, -1416354905);
              b = ii(b, c, d, a, k[5], 21, -57434055);
              a = ii(a, b, c, d, k[12], 6,  1700485571);
              d = ii(d, a, b, c, k[3], 10, -1894986606);
              c = ii(c, d, a, b, k[10], 15, -1051523);
              b = ii(b, c, d, a, k[1], 21, -2054922799);
              a = ii(a, b, c, d, k[8], 6,  1873313359);
              d = ii(d, a, b, c, k[15], 10, -30611744);
              c = ii(c, d, a, b, k[6], 15, -1560198380);
              b = ii(b, c, d, a, k[13], 21,  1309151649);
              a = ii(a, b, c, d, k[4], 6, -145523070);
              d = ii(d, a, b, c, k[11], 10, -1120210379);
              c = ii(c, d, a, b, k[2], 15,  718787259);
              b = ii(b, c, d, a, k[9], 21, -343485551);
            
              x[0] = add32(a, x[0]);
              x[1] = add32(b, x[1]);
              x[2] = add32(c, x[2]);
              x[3] = add32(d, x[3]);
            
            }
            
            function cmn(q, a, b, x, s, t) {
              a = add32(add32(a, q), add32(x, t));
              return add32((a << s) | (a >>> (32 - s)), b);
            }
            
            function ff(a, b, c, d, x, s, t) {
              return cmn((b & c) | ((~b) & d), a, b, x, s, t);
            }
            
            function gg(a, b, c, d, x, s, t) {
              return cmn((b & d) | (c & (~d)), a, b, x, s, t);
            }
            
            function hh(a, b, c, d, x, s, t) {
              return cmn(b ^ c ^ d, a, b, x, s, t);
            }
            
            function ii(a, b, c, d, x, s, t) {
              return cmn(c ^ (b | (~d)), a, b, x, s, t);
            }
            
            function md51(s) {
              var n = s.length,
              state = [1732584193, -271733879, -1732584194, 271733878], i;
              for (i = 64; i <= s.length; i += 64) {
                md5cycle(state, md5blk(s.substring(i - 64, i)));
              }
            
              s = s.substring(i - 64);
              var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
              for (i = 0; i < s.length; i++)
              tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
              tail[i >> 2] |= 0x80 << ((i % 4) << 3);
              if (i > 55) {
                md5cycle(state, tail);
                for (i = 0; i < 16; i++) tail[i] = 0;
              }
            
              tail[14] = n * 8;
              md5cycle(state, tail);
              return state;
            }
            
            /* there needs to be support for Unicode here,
             * unless we pretend that we can redefine the MD-5
             * algorithm for multi-byte characters (perhaps
             * by adding every four 16-bit characters and
             * shortening the sum to 32 bits). Otherwise
             * I suggest performing MD-5 as if every character
             * was two bytes--e.g., 0040 0025 = @%--but then
             * how will an ordinary MD-5 sum be matched?
             * There is no way to standardize text to something
             * like UTF-8 before transformation; speed cost is
             * utterly prohibitive. The JavaScript standard
             * itself needs to look at this: it should start
             * providing access to strings as preformed UTF-8
             * 8-bit unsigned value arrays.
             */
            function md5blk(s) { /* I figured global was faster.   */
              var md5blks = [], i; /* Andy King said do it this way. */
              for (i = 0; i < 64; i += 4) {
                md5blks[i >> 2] = s.charCodeAt(i)
                + (s.charCodeAt(i + 1) << 8)
                + (s.charCodeAt(i + 2) << 16)
                + (s.charCodeAt(i + 3) << 24);
              }
            
              return md5blks;
            }
            
            var hex_chr = '0123456789abcdef'.split('');
            
            function rhex(n)
            {
              var s = '', j = 0;
              for (; j < 4; j++)
              s += hex_chr[(n >> (j * 8 + 4)) & 0x0F]
              + hex_chr[(n >> (j * 8)) & 0x0F];
              return s;
            }
            
            function hex(x) {
              for (var i = 0; i < x.length; i++)
              x[i] = rhex(x[i]);
              return x.join('');
            }
            
            function md5(s) {
              return hex(md51(s));
            }
            
            /* this function is much faster,
            so if possible we use it. Some IEs
            are the only ones I know of that
            need the idiotic second function,
            generated by an if clause.  */
            
            function add32(a, b) {
              return (a + b) & 0xFFFFFFFF;
            }
            
            if (md5('hello') != '5d41402abc4b2a76b9719d911017c592') {
              function add32(x, y) {
                var lsw = (x & 0xFFFF) + (y & 0xFFFF),
                msw = (x >> 16) + (y >> 16) + (lsw >> 16);
                return (msw << 16) | (lsw & 0xFFFF);
              }
            }
            

            
            
            function get_time(unix_timestamp) {
            
              var date = new Date(unix_timestamp);
            
              var h = date.getHours();
              var m = '0' + date.getMinutes();
              var p = ' am';
            
              if (h >= 12) {
                h -= 12;
                p = ' pm';
              }
            
              if (h == 0) {
                h = 12;
              }
            
              return h + ':' + m.substr(m.length - 2) + p;
            }
            
            function get_date(unix_timestamp) {
            
              var date = new Date(unix_timestamp);
            
              var m = date.getMonth();
              var d = date.getDate();
              var y = date.getFullYear();
            
              var m_arr = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
              ];
            
              var fdate = d + ' ' + m_arr[m]  + ' ' + y;
            
              return fdate;
            }
            

            var Parsers = function (r) {
            
              this.type = 'text';
              this.l = {};
              this.m =  r;
            
              //nbr
            
              this.parse = function () {
            
                if (this.m.match(/(^http.+)/))
                for (var i in this) {
                  if (typeof this[i] == 'function' && i != 'parse') {
                    this[i]();
                  }
                }
            
                this.message = this.m;
            
                return {
                  type: this.type,
                  media: (this.type != 'text'),
                  message: this.m,
                  raw: r,
                };
            
              };
            
            };
            
            Parsers.prototype = {
            
              linkify: function () {
            
                var l = this.l;
                var m = this.m;
            
                if (m.match(/(^http.+)/)) {
                  l.url = m;
                  l.text = m;
                }
            
              }, emailify: function () {
            
                var l = this.l;
                var m = this.m;
            
                if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(m)) {
                    l.url = "mailto:"+m;
                    l.text = m;
                    l.target = "_top";
                }
            
            
              }, youtubify: function () {
            
                var l = this.l;
                var m = this.m;
            
                if (m.match(/youtu.be|youtube.com\/watch/)) {
            
                  var yb = 'https://www.youtube.com/embed/$2?controls=1&amp;showinfo=1';
            
                  l.src = l.url
                          .replace(/https:\/\/(www.youtube.com\/watch\?v=)(.+)/, yb)
                          .replace(/https:\/\/(youtu.be)\/(.+)/, yb)
                          .replace(/https:\/\/(m.youtube.com\/watch\?v=)(.+)/, yb)
                          ;
            
                  var amp = l.src.indexOf('&')
            
                  if (amp > 0)
                        l.src = l.src.substring(0,amp)
            
                  this.m = render(
                    '<iframe width="100%" height="" src="{src}" frameborder="0" allowfullscreen="yes" ></iframe>', l);
                  this.l = {};
                  this.type = 'video';
                }
            
              }, imagify: function () {
            
                var l = this.l;
                var m = this.m;
            
                if (l.url && l.url.match(/\.gif|\.png|\.jpe?g/) && !l.src)
                    {
                  l.src = l.url;
                }
              }, cloudify: function () {
            
                var l = this.l;
                var m = this.m;
            
                if (l.url && l.url.match(/\/\/cl.ly\/image/)) {
                  l.url += l.url.match(/gif|png|jpe?g/) ? '' : '/file.png';
                  l.src = l.url.replace(/https?:/, '').replace(/cl.ly/, 'thumbs.cl.ly');
                }
            
              }, compiler: function () {
            
                var l = this.l;
                var m = this.m;
            
                if (l.src) {
                  this.type = 'image';
                  l.text = render('<img src="{src}" data-src="{url}" class="swaychat-load-img" style="visibility:hidden" onload="this.style.visibility = \'visible\'; this.className+=\' swaychat-bounceIn\'" />', l);
                }
            
                if (l.url)
                  this.m =  render('<a href ="{url}" target="_blank">{text}</a>', l);
            
                if (l.target)
                    this.m = this.m.replace('_blank',l.target)
            
                if (l.url && !l.src)
                  this.type = 'link';
            
              },
            };
            

            function convert_filesize(bytesize) {
              var size = bytesize * 0.001;
            
              if (size >= 1000) {
                return (size / 1000).toFixed(1) + ' MB';
              }
            
              if (size.toFixed(1) <= 0) {
                return '0 KB';
              }
            
              return size.toFixed(1) + ' KB';
            }
            

            var templates={agent_details:' <h6> <div class="swaychat-agent-name">{form_title}</div> <span class="swaychat-agent-title">{form_title_sub}</span> </h6>',agent_ini:'<span style="background: {bg}">{initial}</span>',bounce_img:'<img src="{src}" style="display: none" alt="" onload="this.style.display = \'\'; this.className=\'swaychat-bounceIn\'" />',bubble_avatar:' <span style="background:{bg}">{ini}</span> {img} ',bubble:' <div class="swaychat-bubble-wrapper swaychat-bounceIn swaychat-{clientType}"> <div class="swaychat-bubble {style}">{loading} <p {media_class}>{message}</p></div> <span class="swaychat-tail {style}" {hid}>&nbsp;</span> </div> <div class="swaychat-row swaychat-read-receipt swaychat-{clientType}" {hid}> <span>{sent} {time}</span> </div> ',card_message:'<div class="swaychat-card-message"> <div class="swaychat-card-message-content"> {content} </div> <div class="swaychat-card-message-footer"> <h6> {footer} </h6> </div> </div>',chatbox:'<div class="swaychat-chatbox-container"> <div class="swaychat-icons"> <ul> <li class="swaychat-minimize-wrapper"><span class="swaychat-minimize"></span></li> <li class="swaychat-popout-wrapper"><span class="swaychat-popout"><span></span></span> </li> </ul> </div> <div id="swaychat-minimize" class="swaychat-chathead swaychat-primary-bg"> <div class="swaychat-chathead-wrapper"> <div class="swaychat-chathead-img"></div> <div class="swaychat-agent-details"> <h6 class="swaychat-bounceIn"> <div class="swaychat-agent-name">{loading}</div> <span class="swaychat-agent-title">{please_wait}</span> </h6> </div> </div> <div id="swaychat-prechat-header" class="swaychat-chathead-wrapper" style="display:none"> <div class="swaychat-chathead-img"> <div class="swaychat-chathead-src"></div> </div> <div class="swaychat-agent-details"></div> </div> <div id="swaychat-agent-header" class="swaychat-chathead-wrapper" style="display: none"> <div class="swaychat-chathead-img"> <div class="swaychat-badge swaychat-hide"></div> <div class="swaychat-chathead-ini"></div> <div class="swaychat-chathead-src"></div> </div> <div class="swaychat-agent-details"></div> </div> <!-- end agent details --> </div> <!-- chathead end --> <div class="swaychat-chatbox"> <div id="swaychat-modal" class="swaychat-modal swaychat-module"></div> <!--New Wrapper for Form & Powered by--> <div id="swaychat-prechat-form-wrapper" class="swaychat-module"> <div id="swaychat-prechat-form" class="swaychat-row-main"></div> <!--Powered by--> <div class="swaychat-powered"> <h6>{powered_by}<a href="http://swaychat.com" target="_&quot;blank&quot;"><span>Swaychat</span></a></h6> </div> <!--Powered by end--> </div> <!--New Wrapper for Form & Powered by--> <div class="swaychat-conversation swaychat-module" id="swaychat-conversation" tabindex="-1"> </div> <!-- end conversation --> <!--New Messages Alert--> <div class="swaychat-row" id="swaychat-msg-alert"> </div> <!--New Messages Alert End--> <div class="swaychat-upload swaychat-module swaychat-hide" id="swaychat-upload"> </div> <div class="swaychat-message-box swaychat-module" id="swaychat-message-box"> <div class="swaychat-message-wrapper"> <form novalidate id="swaychat-message-reply"> <!--Reply--> <div class="swaychat-reply" id="swaychat-reply"> <textarea id="swaychat-message-text" placeholder="{reply_message}"></textarea> </div> <div class="swaychat-icon-more" id="swaychat-more"></div> <div class="swaychat-send-button"> <button type="submit" class="swaychat-button swaychat-primary-bg" value="Send">{send}</button> </div> </form> <!--Reply End--> </div> <div class="swaychat-dropdown swaychat-hide" id="swaychat-dropdown"> <!--Dropdown Content--> <div class="swaychat-dropdown-content"> <ul id="swaychat-action"> <li class="swaychat-sound swaychat-sound-on"> <span class="swaychat-icon-mute-chat"></span> <span class="swaychat-dropdown-list-text swaychat-text-mute-chat">{disable_sound}</span> <span class="swaychat-icon-unmute-chat"></span> <span class="swaychat-dropdown-list-text swaychat-text-unmute-chat">{enable_sound}</span> </li> <li class="swaychat-attach-files" onclick="event.preventDefault(); document.getElementById(\'swaychat-uploadfile\').click()"> <span class="swaychat-icon-attach"></span> <span class="swaychat-dropdown-list-text swaychat-text-attach-file">{attach_file}</span> <input type="file"> </li> <li style="display: none"> <input type="file" id="swaychat-uploadfile" multiple="multiple"> </li> <li class="swaychat-dropdown-list-last" id="swaychat-show-endchat-confirmation"> <span class="swaychat-icon-end-chat"></span> <span class="swaychat-dropdown-list-text swaychat-text-end-chat">{end_chat}</span> </li> </ul> </div> <!--Dropdown Content End--> </div> <!-- <div class="swaychat-actionbar"> <ul> <li><span><i class="swaychat-icon swaychat-attach">Attach</i></span></li> <li><span><i class="swaychat-icon swaychat-screenshot">Screenshot</i></span></li> <li><span><i class="swaychat-icon swaychat-fb">Facebook</i></span></li> <li><span><i class="swaychat-icon swaychat-tw">Twitter</i></span></li> <li><span><i class="swaychat-icon swaychat-more">More</i></span></li> </ul> </div> --> <!--Powered by--> <div class="swaychat-powered"> <h6>{powered_by}<a href="http://swaychat.com" target="_&quot;blank&quot;"><span>Swaychat</span></a></h6> </div> <!--Powered by end--> </div> </div> <!-- end chatbox --> </div> <!-- container end --> <!--swaychat bubble head --> <div id="swaychat-bubble-head" class="swaychat-chathead"> <div class="swaychat-chathead-img"></div> </div> <!-- end bubble head --> <div id="swaychat-notify"></div> <div class="swaychat-lightbox swaychat-hide"> <div class="swaychat-loading-circle"></div> <div class="swaychat-lightbox-target"></div> </div> <div class="swaychat-attention-grabber swaychat-zoomIn swaychat-hide"> <div class="swaychat-attention-grabber-agents"></div> <div class="swaychat-attention-grabber-message swaychat-zoomIn"></div> <div class="swaychat-form"></div> </div> <!-- <div id="swaychat-notify"> <div class="swaychat-notification swaychat-bounceIn"> <p>{message}<span>{sent} {time}</span></p> <button class="swaychat-nofitication-close">×</button> </div> </div> --> ',default_img:'<img src="{src}" />',end_chat:'<div class="swaychat-modal-content swaychat-rate-success"> <div class="swaychat-rate-wrapper"> <div class="swaychat-rate"> {rates} <hr> <a href="#" class="swaychat-button swaychat-button-expand swaychat-start-new">{start_new_chat}</a> <a href="#" class="swaychat-button swaychat-button-expand swaychat-button-outline swaychat-save-trascript" {no_transcript}>{email_transcript}</a> </div> </div> </div> <div class="swaychat-powered"> <h6>Powered by<a href="http://swaychat.com" target="_&quot;blank&quot;"><span>Swaychat</span></a></h6> </div> ',event:' <div class="swaychat-status swaychat-bounceIn"> <h4><small>{event}</small></h4> <h5><span>{time}</span></h5> </div> ',files_li:'<li> <a href="{url}" id="{id}"> <div class="swaychat-card-message-fileinfo"> <span class="swaychat-card-message-filename">{name}</span> <span class="swaychat-card-message-filesize">{size}</span> </div> </a> </li>',files_ul:' <ul class="swaychat-card-{type}"> {files} </ul> ',form_input:' <div class="swaychat-row"> <input type="{type}" name="{name}" placeholder="{label}" data-required="{required}" value="{value}" /> <!-- <div style="display:none">{error_required}</div> --> </div> ',form_options:' <option value="{value}">{label}</option> ',form_select:'<div class="swaychat-row"> <select name="{name}" data-required="{required}"> <option value="">{label}</option> {form_options} </select> </div> ',form_social_option:'<li data-target="{class}" class="swaychat-signed-li-{class}"><span><i class="swaychat-icon swaychat-signin-{class}">{name}</i></li>',form_social_signed:'<a href="#" class="swaychat-signout-{class}">{label} {name} (<span>Not you?</span>)</a>',form_social:' <div class="swaychat-row"> <div class="swaychat-social-signin {signed} {social}"> <h5 class="swaychat-social-h5">{label}</h5> <h5 class="swaychat-social-h5-signed">{signs}</h5> <ul class="swaychat-social-icons"> {form_options} </ul> </div> </div> ',form_submit:' <div class="swaychat-row"> <button type="submit" class="swaychat-button swaychat-button-expand swaychat-primary-bg" value="{send}">{send}</button> </div>',form_textarea:' <div class="swaychat-row"> <textarea name="{name}" placeholder="{label}" data-required="{required}">{value}</textarea> </div> ',grabber_agent:"{ini}{img} ",grabber_btn:'<button class="swaychat-button swaychat-button-expand">{placeholder}</button> ',grabber_form:'<textarea placeholder="{placeholder}"></textarea> ',grabber_msg:'<div class="swaychat-attention-grabber-title">{title}</div> <div class="swaychat-attention-grabber-subtitle">{msg}</div> ',images_li:'<li> <div class="swaychat-loading-circle"></div> <a href="{url}" data-img="{id}"><img src="{img_src}" id="{id}" alt="" style="visibility: hidden" onload="this.style.visibility = \'visible\'; this.className=\'swaychat-bounceIn\'"></a> </li>',loading_circle:'<div class="swaychat-loading-circle"></div>',new_msg_alert:' <div class="swaychat-conversation-new-message-alert swaychat-bounceIn swaychat-module"> <a href="#"> <span><i class="swaychat-icon-arrow-down-white"></i></span> <span class="swaychat-down-alert">{new_count}</span> </a> </div>',no_rate_modal:'<div class="swaychat-modal-content"> <button class="swaychat-modal-close swaychat-button-close swaychat-modal-close-action">×</button> <div class="swaychat-rate-wrapper"> <div class="swaychat-rate"> <div class="swaychat-rate-label"> <h5><span>{are_you_sure}</span></h5> <br /> </div> </div> </div> <div class="swaychat-row"> <button type="button" class="swaychat-button swaychat-button-expand swaychat-button-end">{end_chat}</button> <button type="button" class="swaychat-button swaychat-button-expand swaychat-button-outline swaychat-modal-close-action">{cancel}</button> </div> </div> ',notify:' <p>{message}<span>{sent} {time}</span></p> <button class="swaychat-notification-close swaychat-button-close">×</button> ',preform:'<!--Form--> <div class="swaychat-form swaychat-form-{type}"> <h5>{welcome}</h5> <form novalidate> <input type="hidden" name="type" value="{type}" /> {form_items} {form_submit} </form> </div> <!--Form End--> ',rate_advance_q:' <!--Question 1--> <div id="swaychat-advanced-rating-{key}" class="swaychat-row swaychat-advanced-rating-item swaychat-fadeInUp" style="display: none"> <h5>{label}</h5> <div class="swaychat-advanced-rating-wrapper"> <table> <tr> <td> <label> <input type="radio" name="{key}" value="1"><span>1</span></label> </td> <td> <label> <input type="radio" name="{key}" value="2"><span>2</span></label> </td> <td> <label> <input type="radio" name="{key}" value="3"><span>3</span></label> </td> <td> <label> <input type="radio" name="{key}" value="4"><span>4</span></label> </td> <td> <label> <input type="radio" name="{key}" value="5"><span>5</span></label> </td> </tr> </table> </div> <div class="swaychat-advanced-rating-question-label"> <span class="swaychat-left-label">{min}</span> <span class="swaychat-right-label">{max}</span> </div> </div> <!--Question 1--> ',rate_advance_submit_1:' <div class="swaychat-columns-half swaychat-columns"> <button type="submit" class="swaychat-button">{send}</button> </div> <div class="swaychat-columns-half swaychat-columns"> <button type="button" class="swaychat-button swaychat-button-outline swaychat-modal-close-action">{cancel}</button> </div> ',rate_advance_submit_2:' <div class="swaychat-row"> <button type="submit" class="swaychat-button swaychat-button-expand">{send}</button> </div>',rate_advance:'<div class="swaychat-modal-content swaychat-advanced-rating swaychat-form"> <form> <div class="swaychat-advanced-rating-questions"> <div class="swaychat-rate"> <div class="swaychat-rate-label"> <h5>{provide_feedback}</h5> </div> <hr> </div> {qs} <div id="swaychat-advanced-rating-comment" class="swaychat-row swaychat-advanced-rating-item swaychat-fadeInUp" style="display: none"> <textarea name="comment" placeholder="Leave a comment..."></textarea> </div> </div> <div class="swaychat-row swaychat-advanced-rating-actions"> <div class="swaychat-section-controls"> <div class="swaychat-arrow-controls swaychat-arrow-previous" title="Previous Question">Previous</div> <div class="swaychat-page-indicator"> <ul> {nav} <li data-key="comment"><span>6</span></li> </ul> </div> <div class="swaychat-arrow-controls swaychat-arrow-next" title="Next Question">Next</div> </div> {submit} </div> </form> </div>',rate_modal:'<div class="swaychat-modal-content"> <button class="swaychat-modal-close swaychat-button-close swaychat-modal-close-action">×</button> <div class="swaychat-rate-wrapper"> <div class="swaychat-rate"> {rates} </div> </div> <div class="swaychat-form swaychat-leave-comment"> <form> <textarea name="comment" placeholder="{leave_comment}"></textarea> {submit} </form> </div> </div> ',rated_modal_submit_1:' <div class="swaychat-columns-half swaychat-columns"> <button type="button" class="swaychat-button swaychat-button-end">{submit}</button> </div> <div class="swaychat-columns-half swaychat-columns"> <button type="button" class="swaychat-button swaychat-button-outline swaychat-modal-close-action">{cancel}</button> </div> ',rated_modal_submit_2:' <div class="swaychat-row"> <button type="button" class="swaychat-button swaychat-button-expand swaychat-button-end">{end_chat}</button> </div> ',rated:' <div class="swaychat-rate-{class} swaychat-bounceIn"><i class="swaychat-rate-icon swaychat-rate-icon-large"></i></div> <h5 class="swaychat-rate-success-label">{rated}<span>{response}</span></h5> ',rates:' <div class="swaychat-rate-label"> <h5><span>{how_did_we_do}</span></h5> </div> <ul> <li class="swaychat-rate-great {r2}" data-rate="2"><i class="swaychat-rate-icon"></i>{great}</li> <li class="swaychat-rate-ok {r1}" data-rate="1"><i class="swaychat-rate-icon"></i>{ok}</li> <li class="swaychat-rate-notgood {r-1}" data-rate="-1"><i class="swaychat-rate-icon"></i>{bad}</li> </ul> ',theme:" .swaychat-primary-bg , .swaychat-button , #swaychat-bubble-head ,.swaychat-chat-widget .swaychat-advanced-rating-wrapper table tr td input:checked + span { background-color: {primary_bg} !important; } #swaychat-chat-widget .swaychat-chathead-img , #swaychat-chat-widget .swaychat-chathead-img img { background-color: {avatar_bg} !important; } .swaychat-chat-widget .swaychat-notification:after { border-color: transparent transparent {primary_bg} transparent; } .swaychat-notification ,.swaychat-chat-widget .swaychat-notification, .swaychat-chat-widget .swaychat-attention-grabber ,.swaychat-chat-widget .swaychat-advanced-rating-wrapper ,.swaychat-chat-widget .swaychat-advanced-rating-wrapper table tr td { border-color: {primary_bg} !important; } .swaychat-button.swaychat-button-outline { background-color: white !important; border-color: {primary_bg} !important; color: {primary_bg} !important; } .swaychat-powered { display: {hide_brand} !important; } .swaychat-popout-wrapper { display: {popout} !important; } .swaychat-toggle-hide { display: none; } ",transcript:' <div class="swaychat-modal-header"> <button class="swaychat-modal-close swaychat-button-close" id="swaychat-close-transcript" title="Close">×</button> </div> <div class="swaychat-modal-content swaychat-rate-success"> <div class="swaychat-rate-wrapper"> <div class="swaychat-rate swaychat-bounceIn"> <h5>{send_chat_transcript_to}</h5> </div> </div> <div class="swaychat-form"> <form id="swaychat-form-transcript" novalidate="novalidate"> <div class="swaychat-row"> <input type="email" name="email" placeholder="{enter_email_address}" value="{email}"> </div> <div class="swaychat-row"> <input type="submit" class="swaychat-button swaychat-button-expand swaychat-button-transcript" value="{send}"> </div> <div id="swaychat-form-transcript-error" class="swaychat-row swaychat-modal-success swaychat-bounceIn swaychat-hide"> <h5>{error_sending_to} <span>{email}</span></h5> </div> <div id="swaychat-form-transcript-success" class="swaychat-row swaychat-modal-success swaychat-bounceIn swaychat-hide"> <h5>{transcript_sent_to} <span>{email}</span></h5> </div> </form> </div> </div> ',typing:' <div class="swaychat-bubble-wrapper swaychat-operator"> <div class="swaychat-typing swaychat-bubble"> <div class="swaychat-spinner"> <span class="swaychat-bounce1"></span> <span class="swaychat-bounce2"></span> <span class="swaychat-bounce3"></span> </div> </div> <span class="swaychat-tail">&nbsp;</span> </div> ',upload_queue:'<div class="swaychat-upload-filename">{name}</div> <div class="swaychat-upload-file-error">Maximum file size: 10mb</div> <div class="swaychat-upload-progressbar-wrapper"> <div class="swaychat-upload-progressbar"></div> </div> <div class="swaychat-upload-file-size">{size}</div> <div class="swaychat-upload-remove-file swaychat-button-close">×</div>',viewport:'<meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0" class="swaychat">'};

            
            function render(t, o) {
            
                if (!t || !o || typeof o != 'object')
                    return;
            
                var s = t;
            
                for (var k in o) {
                    var f = new RegExp('{' + k + '}', 'g');
                    s = s.replace(f, o[k]);
                }
            
                return s;
            }
            
            function get_contrast(hexcolor) {
            
                var r = parseInt(hexcolor.substr(0, 2), 16);
                var g = parseInt(hexcolor.substr(2, 2), 16);
                var b = parseInt(hexcolor.substr(4, 2), 16);
                var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
                return (yiq >= 190) ? 'light' : 'dark';
            
            }
            
            function link_parser(s) {
            
                var r = new RegExp(/\s/);
                var n = s.split(r);
                var t = [];
            
                for (var i = 0; i < n.length; i++)
                    if (n[i].match(/(^http.+)/)) {
            
                        t.push(n[i]);
            
                        if (i < n.length - 1)
                            t.push('');
                    }
                    else {
            
                        if (!t.length)
                            t.push('');
            
                        t[t.length - 1] += (t[t.length - 1] ? ' ' : '') + n[i];
                    }
            
                return t;
            
            }
            
            function sc(v, o) {
            
                var a = v.split(' ');
                var p = 'swaychat-';
            
                p += o ? o + '-' : '';
            
                for (var i = 0; i < a.length; i++) {
                    var t = a[i].substring(0, 1);
                    a[i] = (t == '.' || t == '#') ? t + p + a[i].substring(1) : p + a[i];
                }
            
                return a.join(' ');
            }
            
            function hasPlaceholder() {
            
                var i = document.createElement('input');
                return 'placeholder' in i;
            
            }
            
            String.prototype.toColor = function () {
            
                var hash = 0;
            
                for (var i = 0; i < this.length; i++)
                    hash = this.charCodeAt(i) + ((hash << 7) - hash);
            
                var colour = '#';
            
                for (var i = 0; i < 3; i++) {
                    var value = (hash >> (i * 8)) & 0xFF;
                    colour += ('00' + value.toString(16)).substr(-2);
                }
            
                return colour;
            };
            
            function getuidcolor(str) {
                return str.toColor();
            }
            
            function parse_img(src) {
            
                if (src && src.indexOf('gravatar.com') > 0)
                    src += (src.indexOf('?') > 0 ? '&' : '?') + 'd=blank&s=64';
            
                return src ? render(templates.bounce_img, { src: changeHost(src) }) : '';
            }
            
            function tab_hidden() {
            
                var hidden;
            
                if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
                    hidden = "hidden";
                } else if (typeof document.mozHidden !== "undefined") {
                    hidden = "mozHidden";
                } else if (typeof document.msHidden !== "undefined") {
                    hidden = "msHidden";
                } else if (typeof document.webkitHidden !== "undefined") {
                    hidden = "webkitHidden";
                }
            
                return document[hidden];
            
            }
            
            function hasFocus() {
                return !tab_hidden() && document.hasFocus()
            //        return !tab_hidden();
            }
            
            if (!Object.prototype.swaychat_capitalize)
            String.prototype.swaychat_capitalize = function(lower) {
                return (lower ? this.toLowerCase() : this).replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
            };
            
            function ping(){
            
                var i = 0;
            
                if (hasFocus()) i = 1;
            
                if (t.widget.value.settings.sounds && !t.mute.value && ui.audio[i])
                    ui.audio[i].play();
            
            }
            

            // ----------------------------------------------------------
            // A short snippet for detecting versions of IE in JavaScript
            // without resorting to user-agent sniffing
            // ----------------------------------------------------------
            // If you're not in IE (or IE version is less than 5) then:
            //     ie === undefined
            // If you're in IE (>=5) then you can determine which version:
            //     ie === 7; // IE7
            // Thus, to detect IE:
            //     if (ie) {}
            // And to detect the version:
            //     ie === 6 // IE6
            //     ie > 7 // IE8, IE9 ...
            //     ie < 9 // Anything less than IE9
            // ----------------------------------------------------------
            
            // UPDATE: Now using Live NodeList idea from @jdalton
            
            var ie = (function () {
            
              var undef;
              var v = 3;
              var div = document.createElement('div');
              var all = div.getElementsByTagName('i');
            
              while (
                div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
                all[0]
              );
            
              return v > 4 ? v : undef;
            
            }());
            
            if ( window.XDomainRequest ) {
                
            	$.ajaxTransport(function( s ) {
            		if ( s.crossDomain && s.async ) {
            			if ( s.timeout ) {
            				s.xdrTimeout = s.timeout;
            				delete s.timeout;
            			}
            			var xdr;
            			return {
            				send: function( _, complete ) {
            					function callback( status, statusText, responses, responseHeaders ) {
            						xdr.onload = xdr.onerror = xdr.ontimeout = $.noop;
            						xdr = undefined;
            						complete( status, statusText, responses, responseHeaders );
            					}
            					xdr = new XDomainRequest();
            					xdr.onload = function() {
            						callback( 200, "OK", { text: xdr.responseText }, "Content-Type: " + xdr.contentType );
            					};
            					xdr.onerror = function() {
            						callback( 404, "Not Found" );
            					};
            					xdr.onprogress = $.noop;
            					xdr.ontimeout = function() {
            						callback( 0, "timeout" );
            					};
            					xdr.timeout = s.xdrTimeout || Number.MAX_VALUE;
            					xdr.open( 'GET', s.url + '?' + s.data );
            					xdr.send( ( s.hasContent && s.data ) || null );
            				},
            				abort: function() {
            					if ( xdr ) {
            						xdr.onerror = $.noop;
            						xdr.abort();
            					}
            				}
            			};
            		}
            	});
            }

            // ES 15.2.3.6 Object.defineProperty ( O, P, Attributes )
            // Partial support for most common case - getters, setters, and values
            (function() {
              if (!Object.defineProperty ||
                  !(function () { try { Object.defineProperty({}, 'x', {}); return true; } catch (e) { return false; } } ())) {
                var orig = Object.defineProperty;
                Object.defineProperty = function (o, prop, desc) {
                  // In IE8 try built-in implementation for defining properties on DOM prototypes.
                  if (orig) { try { return orig(o, prop, desc); } catch (e) {} }
            
                  if (o !== Object(o)) { throw TypeError("Object.defineProperty called on non-object"); }
                  if (Object.prototype.__defineGetter__ && ('get' in desc)) {
                    Object.prototype.__defineGetter__.call(o, prop, desc.get);
                  }
                  if (Object.prototype.__defineSetter__ && ('set' in desc)) {
                    Object.prototype.__defineSetter__.call(o, prop, desc.set);
                  }
                  if ('value' in desc) {
                    o[prop] = desc.value;
                  }
                  return o;
                };
              }
            }());
            
            /*
             * object.watch polyfill
             *
             * 2012-04-03
             *
             * By Eli Grey, http://eligrey.com
             * Public Domain.
             * NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
             */
            
            // object.watch
            if (!Object.prototype.watch) {
            	Object.defineProperty(Object.prototype, "watch", {
            		  enumerable: false
            		, configurable: true
            		, writable: false
            		, value: function (prop, handler) {
            			var
            			  oldval = this[prop]
            			, newval = oldval
            			, getter = function () {
            				return newval;
            			}
            			, setter = function (val) {
            				oldval = newval;
            				return newval = handler.call(this, prop, oldval, val);
            			}
            			;
            			
            			if (delete this[prop]) { // can't watch constants
            				Object.defineProperty(this, prop, {
            					  get: getter
            					, set: setter
            					, enumerable: true
            					, configurable: true
            				});
            			}
            		}
            	});
            }
            
            // object.unwatch
            if (!Object.prototype.unwatch) {
            	Object.defineProperty(Object.prototype, "unwatch", {
            		  enumerable: false
            		, configurable: true
            		, writable: false
            		, value: function (prop) {
            			var val = this[prop];
            			delete this[prop]; // remove accessors
            			this[prop] = val;
            		}
            	});
            }

            
            var page;
            var prev_page;
            
            function bind_ref_history() {
            
              var task = $.Deferred();
            
              var sid = t.sid.get()
              if (!sid)
                return setTimeout(bind_ref_history, 1000)
            
              if (isPopOut) {
                  task.resolve()
                return task.promise();
              }
            
              if (ref.history) {
                ref.history.off();
              }
            
              ref.history = fb.child('history').child(t.sid.value);
            
              set_page();
            
              ref.history.child('last_page').once('value', function (snap) {
            
                var v = snap.val();
                if (v) {
                  ref.history.child('pages').child(v).once('value', function (s) {
                    compare_page(s.key(), s.val());
                  });
                } else {
                  post_history();
                }
            
                // Bugsnag.leaveBreadcrumb('Bound History');
            
              });
            
              ref.history.child('page_count').once('value', function (snap) {
                  page_count = snap.val()
                  task.resolve()
              })
            
            
              ref.history.child('prev_page').once('value', function (snap) {
                var v = snap.val();
                if (v) {
                  prev_page = v;
                }
              });
            
              $(window).on('focus', function () {
            
                if (page.key) {
                  ref.history.child('last_page').set(page.key);
                }
            
              });
            
              return task.promise();
            
            }
            
            function set_page() {
            
              if (location.href.indexOf('swaychat.com/testdrive-iframe') > 0) {
                page = {
                  url: '/testdrive',
                  title: 'Testdrive',
                  created_at: Firebase.ServerValue.TIMESTAMP,
                  left_at: Firebase.ServerValue.TIMESTAMP,
                };
              } else {
                page = {
                  url: location.href,
                  title: document.title,
                  created_at: Firebase.ServerValue.TIMESTAMP,
                  left_at: Firebase.ServerValue.TIMESTAMP,
                };
              }
            
            }
            
            function post_history() {
            
              var h = ref.history.child('pages').push(page);
              var k = h.key();
            
              ref.history.child('page_count')
                  .transaction(function (c) {return c + 1;});
            
              page.key = k;
              ref.history.child('pages').child(k).child('left_at').onDisconnect().set(Firebase.ServerValue.TIMESTAMP);
              ref.history.child('last_page').set(k);
            
            }
            
            function compare_page(k, p) {
            
              if (!p || !page) {
                return;
              }
            
              if (p.url != page.url) {
                ref.history.child('prev_page').set(k);
                post_history();
              } else {
                p.key = k;
                page = p;
                ref.history.child('pages').child(k).child('left_at').onDisconnect().set(Firebase.ServerValue.TIMESTAMP);
              }
            
            }
            

            "use strict";function _classCallCheck(e,i){if(!(e instanceof i))throw new TypeError("Cannot call a class as a function")}var _createClass=function(){function e(e,i){for(var t=0;t<i.length;t++){var n=i[t];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(i,t,n){return t&&e(i.prototype,t),n&&e(i,n),i}}(),SwaychatNotifyService=function(){function e(i){_classCallCheck(this,e),Date.now||(Date.now=function(){return(new Date).getTime()}),this.organization=i.toString().split("/").slice(-1)[0],this.notifications=i.child("notifications").child("data")}return _createClass(e,[{key:"notify",value:function(e){var i=e.code,t=void 0===i?1:i,n=e.sender,o=void 0===n?visitor.session_id:n,a=e.receiver,r=void 0===a?this.organization:a,c=e.session,s=void 0===c?visitor.session_id:c,u=e.expiryDuration,l=void 0===u?864e5:u,f=Date.now(),d=[o,t,s].join("|");return this.notifications.child(r).child(d).transaction(function(e){return{created_at:f,expires_at:f+l,count:null===e?1:e.count+1}},function(){},!1)}}]),e}();"undefined"!=typeof module&&"undefined"!=typeof module.exports&&(module.exports=SwaychatNotifyService);

            
            function Reply() {
            
                var tb = $(sc('#message-text'), ui.box);
                var rf = sc('reply-focus');
                var s, isTyping, timer;
                var uploads = {}, rf = {};
                var uploadcare_endpoint = 'https://upload.uploadcare.com/base/';
                
                return {
                    load: load 
                    ,unload: unload
                }
                
                function load(i) {
                    
                    s = i;
                    
                    tb
                        .on('input propertychange', adjust_text_height)
                        .on('keypress', keypress)
                        .on('paste', paste)
                        .on('change', change)
                        .on('focus', focus)
                        .on('blur', blur)
                        
                    ui.box.find(sc('.send-button')).on('focus', send_button_focus)
                    ui.form.on('submit', submit)
                    ui.uploader.on('change',file_upload)
                    
                    
                    rf.messages = fb.child('messages').child(s)
                    rf.messages.child('actions').child('isVisitorTyping').onDisconnect().set(false);
                    
                }
                
                function unload() {
            
                    s = null;
            
                    tb
                        .off('input propertychange', adjust_text_height)
                        .off('keypress', keypress)
                        .off('paste', paste)
                        .off('change', change)
                        .off('focus', focus)
                        .off('blur', blur)
            
                    ui.box.find(sc('.send-button')).off('focus', send_button_focus)
                    ui.form.off('submit', submit)
                    ui.uploader.off('change',file_upload)
                    
                    
                    clear_typing()
                    
                    rf.messages.child('actions').child('isVisitorTyping').onDisconnect().cancel();
                    rf.messages = null;
                    rf = {}
            
                    for (var i in uploads) {
                        uploads[i].unload();            
                        if (uploads[i].done()) delete uploads[i];
                    }
                    
                }
                
                function post_message() {
                
                    var m = tb.val().trim();
                    
                    if (!m) return;
                    
                    var lp = link_parser(m);
                    
                    for (var i = 0; i < lp.length; i++)
                      push_message(lp[i]);
                    
                    tb
                        .val('')
                        .removeClass(sc('textarea-expanded'))
                        .trigger('focus')
                }
                
                function adjust_text_height(e) {
            
                    if (this.value.length > 15) 
                        this.className = sc('textarea-expanded');
                    else
                        this.className = '';
                    
                }
                
                function keypress(e) {
            
                    if (e.which == 13) {
                        e.preventDefault();
                        clear_typing();
                        post_message();
                    } 
                    else 
                        set_typing();
                    
                }    
            
                function paste(e) {
                    
                    var data = (e.clipboardData || e.originalEvent.clipboardData);
                    var items = data.items;
                    
                    if (data.types.length == 1)
                        for (index in items) {
                            var item = items[index];
                            if (item.kind === 'file' && /image/.test(item.type)) {
                                
                                  var blob = item.getAsFile();
                                
                                  blob.name = 'PastedImage.png';
                                  push_files([blob]);
                            
                            }
                        }
                    
                }    
            
                function change(e) {
                    
                    if ($(this).val() == '') 
                      clear_typing();
                    
                }    
            
                
                //handle ios virtual keyboard
            
                function focus(e) {
            
                    $(this).parent().addClass(rf);
                    
                    var el = ui.conversation.get(0);
                    
                    if (el.scrollHeight <= el.offsetHeight && /(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
                        ui.conversation
                            .removeClass(sc('conversation-slideUp'))
                            .addClass(sc('conversation-slideDown'))
                            
                        setTimeout(function () {
                            ui.conversation
                                .css('top', 'auto');
                        }, 300);
                    }
                    
                }    
            
                function blur(e) {
            
                    $(this).parent().removeClass(rf);
                    
                    var el = ui.conversation.get(0);
                    
                    if (el.scrollHeight <= el.offsetHeight && /(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
                        ui.conversation
                            .removeClass(sc('conversation-slideUp'))
                            .addClass(sc('conversation-slideDown'))
                            
                        setTimeout(function () {
                            ui.conversation
                                .css('top', 'auto');
                        }, 300);
                    }
                    
                }
                
                function set_typing() {
                
                    if (!isTyping) 
                        rf.messages.child('actions').child('isVisitorTyping').set(true);
                    
                    clearTimeout(timer);
                    timer = setTimeout(clear_typing, 2000);
                
                }
                
                function clear_typing() {
                
                    clearTimeout(timer);
                    isTyping = false;
                    rf.messages.child('actions').child('isVisitorTyping').set(false);
                
                }
                
                function send_button_focus(e) {
            
                    e.preventDefault();
                    tb.trigger('focus');
                    
                }
                
                function submit(e) {
            
                    e.preventDefault();
                    post_message();
                    
                }
                
            //uploader
            
                function file_upload(e) {
                    
                    push_files(this.files)
                    $(this).val('');
                    
                }
                
                function push_files(files) {
            
                    var data = {
                        type: 2
                        ,count: 0
                        ,meta: {}
                    }        
                    
                    for (var i = 0; i < (files.length<=3 ? files.length : 3); i++)
                        {
                            data.meta[i] = get_meta(files[i])
                            data.count += 1;
                        }
                        
                    var k = push_message(data)
                    
                    for (var i in data.meta)
                        uploads[k+i] = new Upload(s,k,i,files[i])
                    
                }
                
                function get_meta(file) {
            
                        var ext = file.name.split('.').pop().toLowerCase();
                        
                        return {
                            name: file.name
                            ,size: file.size
                            ,upload: 0
                            ,format: ext.length < 4 ? ext : ''
                            ,format_type: ['jpg','jpeg','png','gif','bmp','webp'].indexOf(ext) > -1 ? 'image' : ext
                        }
                    
                }
                
                function Upload(s,k,i,file) {
                    
                    var done = false;
                    var r = fb.child('messages').child(s).child('data').child(k).child('meta').child(i);
            
                    var fd = new FormData();
                    var XHR = new window.XMLHttpRequest();
                    var prg = document.createElement('div');
                    var row = document.createElement('div');
            
                    row.className = sc("upload-file-list");
                    prg.className = sc("upload-progressbar-value primary-bg");
            
                    fd.append('UPLOADCARE_PUB_KEY', '4f9a6e195439d01d3dfe');
                    fd.append('UPLOADCARE_STORE', 1);
                    fd.append('file', file);
            
                    ui.upload
                        .removeClass(hide)
                        .append(row);
            
                    $(row).html(
                        render(templates.upload_queue, {
                            name: file.name,
                            size: convert_filesize(file.size),
                        })
                    );
            
                    $(sc('.upload-progressbar'), row).html(prg);
                    $(prg).css("width", "0%");
            
                    $(row).on('click', sc('.upload-remove-file'),abort);
            
                    if (file.size > 10000000)
                        abort()
                    else
                        upload()
            
                    return {
                        unload: unload
                        ,done: is_done
                    }
                    
                    function upload() {
            
                        r.child('abort').onDisconnect().set(true)
            
                        $.ajax({
                            url: uploadcare_endpoint
                            , data: fd
                            , processData: false
                            , contentType: false
                            , type: 'POST'
                            , xhr: function () {
                                XHR.upload.addEventListener('progress', progress, false);
                                return XHR;
                            }
                            , success: success
                        });
                                
                    }
                    
                    function is_done() {
                        return done;
                    }
                    
                    function progress(e) {
                        var percent = Math.round((e.loaded / e.total) * 100);
                        $(prg).css("width", percent + '%');
                        r.child('upload').set(percent)
                    }
                    
                    function success(data) {
                        done = true;
                        r.child('abort').onDisconnect().cancel()
                        r.child('url').set("//www.ucarecdn.com/" + data.file + "/")
                        
                        if (hasIntegrations) {
                            _Integrations.push({
                                org_id: org_id,
                                sid: s,
                                did: k,
                                i: i
                            });
                        }
            
                        unload()            
                    }
                    
                    function abort(e) {
                        r.child('abort').onDisconnect().cancel()
                        r.child('abort').set(true)
                        done = true;
                        if (e) {
                            XHR.abort();
                            unload()
                        } else
                            $(row).addClass(sc('upload-error'))
                    }        
                    
                    function unload() {
                        
                        $(row)
                            .off('click', '.upload-remove-file',abort)
                            .remove();
                        
                        for (var i in uploads)
                            if (!uploads[i].done()) return;
                            
                        ui.upload.addClass(hide);
                            
                    }
                    
                }
                
                    
            
            
            }

            
                function Preload() {
            
                    var sq = [], pre, dPo;
                    
                    return {
                        load: load
                        , loaded: loaded
                        , unload: unload
                        , push: push
                        , hide: hide
                    }
                    
                    function loaded() {
                        if (pre)
                            return true;
                        
                        return false;
                    }
                    
                    function unload() {
                        hide()
                        sq = [];
                        t.sq.set(sq);
                        clearTimeout(dPo)
                    }
            
                    function load() {
                    
                        var nq = [];
                    
                        if (t.sq.value) 
                            nq = t.sq.value;
                            
                        pre = {};
                        
                        if (!nq.length) return;
                        
                        for (var i = 0; i < nq.length; i++) {
                            
                            var l = null;
                            var k = nq[i].t;
                            var v = nq[i].d;
                            
                            pre[i] = $('<div />');
                            var m = '';
                            var tm = '';
                            var sn = '<i></i><i></i><i></i><i></i>';
                            
                            for (var h = 0; h < 5; h++)
                                tm += '<i></i>';
                            
                            tm += ' <i></i><i></i>';
                            
                            if (k == 'o' || k == 'v') {
                            
                                if (!v[0])
                                for (var h = 0; h < v[1]; h++)
                                m += '<i></i>';
                                
                                else m = "<b></b>";
                                
                                if (nq[i + 1]) l = nq[i + 1].t;
                                
                                var ms = render(templates.bubble, {
                                message: m, sent: sn, time: tm, clientType: k == 'o' ? 'operator' : 'visitor', style: k == 'v' ? sc('primary-bg') : '', hid: l == k ? 'style="display:none"' : '', media_class: v[0] ? 'class="' + sc('bubble-media') + '"' : '', loading: '',
                                });
                            
                            }        
                            else if (k == 'e') {
                            
                                for (var h = 0; h < v; h++)
                                m += "<i></i>";
                                
                                var ms = render(templates.event, {
                                event: m,
                                time: tm,
                                });
                            
                            }        
                            else if (k == 'g') {
                            
                                for (var h = 0; h < v; h++)
                                m += "<i></i>";
                                
                                var ms = render(templates.event, {
                                event: '',
                                time: m,
                                });
                                
                                pre[i].addClass(sc('group-time'))
                            
                            }        
                            else if (k == 'a') {
                            
                                for (var h = 0; h < v[0]; h++)
                                    m += "<i></i>";
                                
                                var mi = "";
                                var mf = "";
                                var cm = "";
                                
                                for (var h = 0; h < v[1]; h++)
                                    mi += "<li></li>";
                                
                                var mc = "";
                                
                                for (var j = 0; j < 20; j++)
                                    mc += "<i></i>";
                                
                                for (var h = 0; h < v[2]; h++)
                                    mf += "<li>" + mc + "</li>";
                                
                                if (mi)
                                    mi = render(templates.files_ul,{type:'gallery',files:mi})
                                
                                if (mf)
                                    mf = render(templates.files_ul,{type:'files',files:mf})
                                
                                if (mi || mf)
                                    cm = render(templates.card_message, {
                                        content: mi+mf,
                                        footer: '<i></i><i></i>'+tm
                                    })
                                
                                var ms = render(templates.event, {
                                    event: m,
                                    time: tm
                                    }) + cm;
                            
                            }
                            
                            pre[i].addClass(sc('row faux'))
                                .html(ms)
                                
                            ui.conversation
                                .append(pre[i])
                            
                        
                        }
            
                        ui.conversation
                            .scroll_end(true)
                    
                    }
            
                    function hide() {
                        
                        if (pre)
                            for (var i in pre)
                                pre[i].remove()
                                
                        pre = null;
            
                    }
                    
                    function push(k, l) {
            
                        sq.push({ t:k, d:l });
            
                        defer_push_save();
                        
                    }
                    
                    function defer_push_save() {
                        
                        clearTimeout(dPo)
                        dPo = setTimeout(push_save, 100)
                        
                    }
                    
                    function push_save() {
                        t.sq.set(sq)
                    }                
                    
                }
            

            
                function Event(data) {
            
                    var rf = {};
            
                    rf.agents = fb.child('agents');
                
                    var box = $('<div />',{class : sc('row')})
                                .append(render(templates.event,data))
                                ;
                
                    if (box.find(sc('.operator_name')).length) {
                        rf.agents.child(box.find(sc('.operator_name')).data('id')).child('nickname').on('value',update_agent)
                    }
                        
                    return { 
                        box : box 
                        ,from : data.from
                        ,unload : unload
                        ,new_event : true
                    }
            
                    function update_agent(snap) {
                        box.find(sc('.operator_name')).text(snap.val());
                    }
                    
                    function unload() {
                
                        if (box.find(sc('.operator_name')).length)
                            rf.agents.child(box.find(sc('.operator_name')).data('id')).child('nickname').off('value',update_agent)
                            
                        box.remove()
                        
                    }
                    
                }
                
            

            
                function Bubble(data) 
                {
                    
                    var message = data.message;
                    var rf = {};
            
                    rf.agents = fb.child('agents');
                    rf.session = fb.child('sessions').child(t.sid.value);
                    
                    $.extend(data, new Parsers(data.message).parse())
                    data.media = (data.type == 'image' || data.type == 'video');
                    data.media_class = data.media ? 'class="' + sc('bubble-media') + '"' : '';
                    data.loading = data.media ? templates.loading_circle : '';
                
                    var box = $('<div />',{class : sc('row')});
                        box
                        .html(render(templates.bubble,data))
                        .on('click',function(){
                            $(this).toggleClass(sc('receipt-off'));  
                        })
                        ;
                
                    var ba = $('<div class="swaychat-operators-avatar">');
                    
                        if (data.from != org_id)
                            box.find(sc('.read-receipt')).prepend(ba);
                            
                    if (data.clientType == 'operator' && data.from != org_id) 
                        rf.agents.child(data.from).on('value',update_agent)
                    else if (data.from == t.uid.value)
                        rf.session.child('meta').on('value',update_avatar)    
                    
                    if (data.type == 'image')
                        $('a', box)
                        .on('click', function (e) {
                          
                            e.preventDefault();
                            e.stopPropagation();
                            
                            var src = $('img', this).data('src');
                            
                            p.ui.lightbox
                              .removeClass(hide)
                              .find(sc('.lightbox-target'))
                              .html(render(templates.bounce_img, { src: src }));
                        
                        })
                        .on('click',function(e){
                        e.stopPropagation()
                        })
                        .find('img')
                        .on('load',ui.conversation.scroll_end)
                        ;
                    
                    return {
                        from: data.from
                        , clientType: data.clientType
                        , box: box
                        , media: data.media
                        , message: message
                        , time: data.time
                        , unload: unload
                    };
                    
                
                    function update_agent(ag) {
                
                        var a = ag.val();
                        var k = ag.key();
            
                        var img = parse_img(a.avatar);
                        
                        ba
                        .attr('title',a.nickname)
                        .html(render(templates.bubble_avatar,{
                            bg: getuidcolor(k)
                            , ini: a.nickname.substring(0,1)
                            , img: img
                        }))
            
                            
                    }
                        
                    function update_avatar(snap) {
                        
                        var va = snap.val();
                        var img = parse_img(va.avatar);
                        var name = va.name || va.email || '';
            
                        if (!name) {
                            ba.remove()
                            return;   
                        }
                        
                        ba
                        .attr('title', name)
                        .html(render(templates.bubble_avatar, {
                            bg: getuidcolor(data.from)
                            , ini: name ? name.substring(0, 1) : ''
                            , img: img
                        }))
                        .addClass(sc('visitors-avatar'))
                        
                    }
                    
                    function unload()
                        {
                            
                        if (data.clientType == 'operator' && data.from != org_id)
                            rf.agents.child(data.from).off('value',update_agent)
                        else if (data.from == t.uid.value)
                            rf.session.child('meta').off('value',update_avatar)
                            
                        if (data.type == 'image')
                            box.find('img').off('load',ui.conversation.scroll_end)
                            
                            ba.remove()
                            box.remove()
                        }
                        
                
                }
            

            
                function Attachment(data) {
            
                    var rf = {};
            
                    rf.agents = fb.child('agents');
                    rf.messages = fb.child('messages').child(t.sid.value);
            
                    var box = $('<div />',{
                                    class :  sc('row')
                                })
                                .html(render(templates.event,data))
                                ;
            
                    if (box.find(sc('.operator_name')).length)
                        rf.agents.child(box.find(sc('.operator_name')).data('id')).child('nickname').on('value',update_agent)
            
                    var dt = {};
            
                    dt.content = '';
                    dt.footer = '';
                    dt.files = 0;
                    dt.images = 0;
                    dt.gallery = { type: 'gallery' , files: ''};
                    dt.list = { type: 'list' , files: ''};;
            
                    for (var i in data.files) {
                        var file = data.files[i];
                        if (file.format_type == 'image')
                            {
                                var dgf = {
                                    url: ''
                                    ,img_url: ''
                                    ,img_src: ''
                                    ,id: 'swaychat-thumb-' + data.key + i
                                }
            
                                file.id = dgf.id;
                                file.updater = new ImageUpdater(file);
            
                                dt.gallery.files += render(templates.images_li,dgf)
                                dt.images += 1;
                            }
                        else
                            {
                                var dff = {
                                    name: file.name
                                    ,size: file.upload ? '' : convert_filesize(file.size)
                                    ,id: 'swaychat-file-' + data.key + i
                                }
            
                                dt.list.files += render(templates.files_li,dff)
                                dt.files += 1;
            
                                file.id = dff.id;
                                file.updater = new FileUpdater(file);
            
                            }
                    }
            
                    dt.content += dt.gallery.files ? render(templates.files_ul,dt.gallery) : ''
                    dt.content += dt.list.files ? render(templates.files_ul,dt.list) : ''
            
                    dt.footer_img = dt.images ? dt.images + ' image' + (dt.images > 1 ? 's':'') : '';
                    dt.footer_file = dt.files ? dt.files + ' file' + (dt.files > 1 ? 's':'') : '';
            
                    dt.footer = dt.footer_img + ((dt.footer_file && dt.footer_img)?', ':'') + dt.footer_file;
            
                    box.append(render(templates.card_message,dt))
            
                    if (dt.images)
                        $('.swaychat-card-gallery a',box)
                        .on('click', function (e) {
            
                            e.preventDefault();
            
                            var src = $('img', this).data('src').replace('/scale_crop/240x240/center/','/progressive/yes/-/preview/');
            
                            ui.lightbox
                              .removeClass(hide)
                              .find(sc('.lightbox-target'))
                              .html(render(templates.bounce_img, { src: src }));
            
                        })
            
                    return {
                        box : box
                        ,from : data.from
                        ,unload : unload
                        ,new_event : true
                        ,image_count: dt.images
                        ,file_count: dt.files
                    }
            
                    function ImageUpdater(file) {
            
                        var to;
            
                        rf.messages.child('data').child(data.key).child('meta').child(i).child('url').on('value',update_url)
                        rf.messages.child('data').child(data.key).child('meta').child(i).child('abort').on('value',abort)
            
                        return {
                            unload: unload
                        }
            
                        function update_url(snap) {
                            file.url = snap.val();
                            const fileUrl = changeHost(file.url);
            
                            if (fileUrl)
                            setTimeout(function(){
                            $('#'+file.id)
                                .on('error', handle_img)
                                .on('load', remove_handle_img)
                                .attr('src',fileUrl  + '-/scale_crop/240x240/center/')
                                .attr('data-src',fileUrl  + '-/scale_crop/240x240/center/')
                                .parent()
                                .attr('href',fileUrl)
                            }, 100)
                        }
            
                        function remove_handle_img(e) {
                            clearTimeout(to)
                            $(this).off('error')
                        }
            
                        function handle_img(e) {
                            var src = $(this).data('src');
                            var img = this;
                            to = setTimeout(function(){ img.src = ''; img.src = src; },10000)
                        }
            
                        function abort(snap) {
            
                            if (snap.val())
                            setTimeout(function(){
            
                            $('#'+file.id)
                                .parent()
                                .siblings()
                                .detach()
            
                            $('#'+file.id)
                                .off('error')
                                .detach()
            
                            }, 100)
            
                        }
            
                        function unload() {
            
                            clearTimeout(to)
            
                            rf.messages.child('data').child(data.key).child('meta').child(i).child('url').off('value',update_url)
                            rf.messages.child('data').child(data.key).child('meta').child(i).child('abort').off('value',abort)
                        }
            
                    }
            
                    function FileUpdater(file) {
            
                        rf.messages.child('data').child(data.key).child('meta').child(i).child('upload').on('value',update_size)
                        rf.messages.child('data').child(data.key).child('meta').child(i).child('url').on('value',update_url)
                        rf.messages.child('data').child(data.key).child('meta').child(i).child('abort').on('value',abort)
            
                        return {
                            unload: unload
                        }
            
                        function update_size(snap) {
            
                            var p = snap.val()
                            if (p && p < 100)
                                p = p+'%';
                            else
                                p = convert_filesize(file.size);
            
                            $('#'+file.id+' .swaychat-card-message-filesize').text(p)
            
                            setTimeout(function(){
                                $('#'+file.id+' .swaychat-card-message-filesize').text(p);
                            }, 100)
                        }
            
                        function update_url(snap) {
                            file.url = snap.val();
                            const fileUrl = changeHost(file.url);
            
                            if (fileUrl)
                            setTimeout(function(){
                                $('#'+file.id).attr('href',fileUrl)
                            }, 100)
                        }
            
                        function abort(snap) {
            
                            if (snap.val())
                            setTimeout(function(){
                               $('#'+file.id+' .swaychat-card-message-filesize').text('Failed');
                            }, 100)
            
                        }
            
                        function unload() {
                            rf.messages.child('data').child(data.key).child('meta').child(i).child('upload').off('value',update_size)
                            rf.messages.child('data').child(data.key).child('meta').child(i).child('url').off('value',update_url)
                            rf.messages.child('data').child(data.key).child('meta').child(i).child('abort').off('value',abort)
                        }
            
                    }
            
                    function update_agent(snap) {
                        box.find(sc('.operator_name')).text(snap.val());
                    }
            
                    function unload()
                    {
            
                        if (box.find(sc('.operator_name')).length)
                            rf.agents.child(box.find(sc('.operator_name')).data('id')).child('nickname').off('value',update_agent)
            
                        for (var i in data.files)
                            if (data.files[i].updater) data.files[i].updater.unload()
            
                        box.remove()
            
                    }
            
            
                }
            

            function Grabber() {
            
              var agents = {};
            
              var ui_box = $(sc('.attention-grabber'), ui.box)
              var ui_agents = $(sc('.attention-grabber-agents'), ui.box)
              var ui_msg = $(sc('.attention-grabber-message'), ui.box)
              var ui_btn = $(sc('.attention-grabber .form'), ui.box)
              var ui_blank = ''
            
              load()
            
              return {
                show: show,
                hide: remove,
              }
            
              function load() {
            
                if (!t.widget.value || !t.widget.value.theme || !t.widget.value.theme.primary_bg)
                  return setTimeout(load, 1000)
            
                var w = fb.child('widgets').child(widget_id);
                ui_blank = new Blank()
            
                w.child('onlineAgentsList').on('child_added', add_agent)
                w.child('onlineAgentsList').on('child_removed', remove_agent)
                fb.child('visitors').child(t.uid.get()).child('window_minimize').on('value', minimize)
            
                ui.box.on('click', sc('.attention-grabber, .attention-grabber .form textarea'), function() {
                  ui.bubblehead.trigger('click');
                })
            
                if (!online())
                    ui_agents.append(ui_blank.li);
            
              }
            
              function show(data) {
            
                if (p.hidden
                    || $('#swaychat').data('hidden')
                    || t.banned.get()
                    || (isPopOut)
                    || !t.minimize.get()
                ) return;
            
                ui_msg.html(render(templates.grabber_msg, data));
                ui_btn.html(render(templates['grabber_' + data.button_type], data));
                ui_box.removeClass(sc('hide'));
            
                var sec = data.time || 20;
                ping()
            
                setTimeout(remove, 1000 * sec);
            
              }
            
              function minimize(snap) {
                if (!snap.val())
                  remove()
              }
            
              function remove() {
                ui_box.addClass(sc('hide'));
              }
            
              function add_agent(snap) {
            
                var k = snap.key();
                agents[k] = new Agent(k);
            
                update_list()
            
              }
            
              function remove_agent(snap) {
            
                var k = snap.key();
                agents[k].unload()
                delete agents[k];
            
                update_list()
            
              }
            
              function update_list() {
            
                var len = $('div', ui_agents).length;
                var arr = [];
                for (var i in agents) {
                  agents[i].li.detach()
                  arr.push(i)
                }
            
                $('div', ui_agents).detach();
            
                if (arr.length) {
            
                    arr.sort(function() {
                      return .5 - Math.random();
                    })
            
                    for (var i = 0; i < arr.length; i++) {
                      ui_agents.append(agents[arr[i]].li);
                    }
            
                }
                else
                    ui_agents.append(ui_blank.li)
            
              }
            
              function Blank() {
                var li = $('<div class="swaychat-operators-avatar swaychat-zoomIn" />');
            
                li
                    .css('background', t.widget.value.theme.primary_bg)
                    .html(render(templates.grabber_agent,{
                        ini: '',
                        img: parse_img(cdn + "img/sc-header-icon-default-4.png")
                    }))
            
                return {
                    li: li
                }
              }
            
              function Agent(k) {
            
                var li = $('<div class="swaychat-operators-avatar swaychat-zoomIn" />');
                fb.child('agents').child(k).on('value', update_agent);
            
                return {
                  li: li,
                  unload: unload
                };
            
                function update_agent(ag) {
            
                  var a = ag.val();
                  var k = ag.key();
                  var img = parse_img(a.avatar);
            
                  li
                    .attr('title', a.nickname)
                    .css('background', getuidcolor(k))
                    .html(render(templates.grabber_agent, {
                      ini: a.nickname.substring(0, 1),
                      img: img
                    }))
            
                }
            
                function unload() {
            
                  fb.child('agents').child(k).off('value', update_agent);
                  li.off()
                  li.remove()
            
                }
            
            
              }
            
            
            }
            

            
                function pop_message(msg) {
            
                    if (!t.minimize.get()) return;
            
                    if (lastnotify && lastnotify.unload) lastnotify.unload()
                    lastnotify = new Pop_Notify(msg)
            
                }
            
                function Pop_Notify(data) {
            
                    if (!t.minimize.value || t.popout.value)
                        return false;
            
                    if (t.widget.value.theme.startup_mode == 'link')
                        ui.box.removeClass(hide)
            
                    if (t.hidden.value) {
                        is_hide_expire(true);
                        ui.box.removeClass(hide)
                    }
            
                    if (!data.time)
                        data.time = get_time(new Date());
            
                    var to, box = $('<div />')
                        .addClass(sc('notification bounceIn'));
            
                    data.sent = t.widget.value.language.sent;
            
                    box.html(render(templates.notify, data))
                        .on('click', function (e) {
                            unload(e);
                            ui.bubblehead.trigger('click');
                        });
            
                    box.on('click',sc('.notification-close'),unload)
                    $(document).on('swaychat-maximize', unload)
                    to = setTimeout(unload, 20 * 1000);
            
                    ui.notify.append(box)
                    ping()
            
                    return {
                        unload: unload
                    };
            
                    function unload(e) {
            
                        if (e)
                            e.stopPropagation()
            
                        box
                            .removeClass(sc('bounceIn'))
                            .addClass(sc('zoomOut'))
                            .off('click',sc('.notification-close'),unload)
            
                        $(document).off('swaychat-maximize', unload)
                        clearTimeout(to)
            
                        setTimeout(function () {
                            box.remove();
                        }, 300);
            
                    }
            
            
                }
            

            function bind_ref_messages() {
            
              var sid = t.sid.get()
              if (!sid)
                return setTimeout(bind_ref_messages, 1000)
            
                if (chat && chat.sid() != t.sid.value) {
                    preload.unload()
                    chat.unload()
                    chat.load();
                } else {
                    chat = new Chat()
                    chat.load();
                }
            
                return true;
            }
            
            
            function Chat() {
            
                var s, messages, msg_count, read, dUu, rf = {},
                    lm, loaded = false,
                    dFl, dOn, last_d;
                var groups = {};
            
                if (!ui.typing)
                    ui.typing = $('<div />', {
                        class: sc('row')
                    }).html(templates.typing)
            
                return {
                    load: load,
                    unload: unload,
                    sid: sid
                }
            
                function sid() {
                    return s;
                }
            
                function load() {
            
                    s = t.sid.value;
            
                    ui.reply.load(s)
            
                    messages = [];
            
                    rf.messages = fb.child('messages').child(s)
                    rf.messages.child('data').on('child_added', process_item);
                    rf.messages.child('read').child(t.uid.value).on('value', update_read)
                    rf.messages.child('visitor_msg_count').on('value', update_msg_count)
                    rf.messages.child('actions').child('isOperatorTyping').on('value', show_typing)
            
                    $(document).on('swaychat_bottom_reached swaychat-maximize', bottom_reached)
            
                    // Bugsnag.leaveBreadcrumb('Messages Loaded');
            
                }
            
                function unload() {
            
                    s = null;
            
                    clearTimeout(dFl)
                    loaded = false;
            
                    ui.reply.unload()
            
                    rf.messages.child('data').off('child_added', process_item);
                    rf.messages.child('visitor_msg_count').off('value', update_msg_count)
                    rf.messages.child('read').child(t.uid.value).off('value', update_read)
                    rf.messages.child('actions').child('isOperatorTyping').off('value', show_typing)
            
                    if (last_d) {
                        rf.messages.child('data').child(last_d).onDisconnect().cancel()
                        _Integrations.child(last_d).onDisconnect().cancel()
                    }
            
                    rf.messages = null;
            
                    for (var i = 0; i < messages.length; i++)
                        messages[i].unload()
            
                    messages = null;
                    clearTimeout(dUu);
            
                    $(document).off('chat_bottom_reached', bottom_reached)
            
                    for (var i in groups)
                        groups[i].remove()
            
                    groups = {};
            
                }
            
                //binds
            
                function process_item(snap) {
            
                    if (preload.loaded())
                        preload.hide()
            
                    var m = snap.val();
                    var k = snap.key();
                    var pi;
            
                    var lang = $.extend(def_lang, t.widget.value.language);
            
                    switch (m.type) {
                        case 0:
                        case 3:
                            if (!m.private)
                                pi = process_message(m)
                            break;
                        case 1:
                            if (!m.private)
                                pi = process_event(m)
            
                            if (m.subtype == 2 && !m.updated_at) {
                                rf.messages.child('data').child(k).child('updated_at').set(fb_time)
            
                                if (hasIntegrations) {
                                    _Integrations.push({
                                        org_id: org_id,
                                        sid: s,
                                        type: 'visitor_reconnected'
                                    });
                                }
                            }
            
                            break;
                        case 2:
                            if (!m.private)
                                pi = process_attachment(m, k)
                            break;
                    }
            
                    if (pi) {
            
                        var m_day = get_date(m.created_at);
                        var t_day = get_date(new Date().getTime());
            
                        var day_group = sc('group_key_' + m_day.replace(' ', ''));
                        var new_group;
            
                        if (!groups[day_group]) {
            
                            groups[day_group] = $('<div class="' + sc('row group-time') + '" />')
                                .html(render(templates.event, {
                                    event: '',
                                    time: (m_day == t_day) ? lang.today : m_day
                                }))
            
                            ui.conversation
                                .append(groups[day_group])
            
                            new_group = true;
                            preload.push('g', m_day.length)
            
                        }
            
                        messages.push(pi);
                        preload.push(pi.pre_type, pi.pre_data)
            
                        var i = messages.length;
            
                        if (m.type == 0 && i > 1) {
            
                            var a = messages[i - 2];
                            var b = messages[i - 1];
            
                            if (a.from == b.from && !a.new_event && !new_group)
                                a.box.addClass(sc('receipt-off'))
            
                            if (pi.clientType == 'operator')
                                lm = i - 1;
            
                        }
            
                        if (!loaded)
                            defer_loaded()
                        else
                        if (ui.conversation.is(":visible"))
                            ping()
            
                        ui.conversation
                            .append(pi.box)
                            .scroll_end(m.from == t.uid.value, loaded);
            
                    }
            
                    if (m.type != 1 && m.subtype != 2)
                        defer_update_ondisconnect(k)
            
                }
            
                function defer_update_ondisconnect(k) {
            
                    clearTimeout(dOn)
            
                    dOn = setTimeout(function() {
            
                        if (last_d) {
                            rf.messages.child('data').child(last_d).onDisconnect().cancel()
                            _Integrations.child(last_d).onDisconnect().cancel()
                        }
            
                        var data = {
                            from: t.uid.value,
                            status: false,
                            type: 1,
                            subtype: 2,
                            created_at: fb_time,
                        }
                        var integrationData = {
                            org_id: org_id,
                            sid: s,
                            type: 'visitor_disconnected'
                        }
            
                        last_d = k + '_' + new Date().getTime();
                        rf.messages.child('data').child(last_d).onDisconnect().set(data)
            
                        if (hasIntegrations) {
                            _Integrations.child(last_d).onDisconnect().set(integrationData);
                        }
            
                    }, 100)
            
                }
            
                function defer_loaded() {
                    clearTimeout(dFl)
                    dFl = setTimeout(function() {
                        loaded = true;
                    }, 300)
                }
            
            
                function process_message(m) {
            
                    var data = {
                        message: m.message,
                        clientType: (m.from != t.uid.value) ? 'operator' : 'visitor',
                        time: get_time(m.created_at),
                        timestamp: m.created_at,
                        style: (m.from != t.uid.value) ? '' : sc('primary-bg'),
                        sent: t.widget.value.language.sent,
                        from: m.from
                    };
            
            
                    var bubble = new Bubble(data);
            
                    bubble.pre_type = data.clientType == 'operator' ? 'o' : 'v';
                    bubble.pre_data = [bubble.media, data.message.length]
            
                    return bubble;
            
                }
            
                function process_event(m) {
            
            
                    var data = {
                        clientType: (m.from != t.uid.value) ? 'operator' : 'visitor',
                        from: m.from,
                        time: get_time(m.created_at)
                    }
            
                    var lang = $.extend(def_lang, t.widget.value.language);
            
                    if (data.clientType == 'operator') {
                        var tname = t.agent.value && t.agent.key == m.from ? t.agent.name : ''
                        data.name = '<b class="swaychat-operator_name" data-id="' + m.from + '">' + tname + '</b>';
                    } else
                        data.name = '<b>You</b>'
            
                    switch (m.subtype) {
                        case 0:
                            data.event = render(lang.left, data);
                            break;
                        case 1:
                            data.event = data.clientType == 'operator' ? render(lang.joined, data) : lang.you_have_joined;
                            break;
                        case 7:
                            data.event = render(lang.rated, {
                                rating: lang.ratings[m.rate].label
                            });
                            break;
                        case 8:
                            data.event = lang.commented;
                            break;
                        default:
                            return false;
                    }
            
            
                    var event = new Event(data);
            
                    event.pre_type = 'e';
                    event.pre_data = data.event.replace(/<(?:.|\n)*?>/gm, '').length;
            
                    return event;
            
                }
            
                function process_attachment(m, k) {
            
                    if (!m.meta) return;
            
                    var data = {
                        clientType: (m.from != t.uid.value) ? 'operator' : 'visitor',
                        from: m.from,
                        count: m.count ? m.count : '',
                        time: get_time(m.created_at),
                        key: k,
                        s: (m.count && m.count > 1) ? 's' : ''
                    }
            
                    var lang = $.extend(def_lang, t.widget.value.language);
            
                    if (data.clientType == 'operator') {
                        var tname = t.agent.value && t.agent.key == m.from ? t.agent.name : ''
                        data.name = '<b class="swaychat-operator_name" data-id="' + m.from + '">' + tname + '</b>';
                    } else
                        data.name = '<b>You</b>'
            
                    data.event = render(lang.added, data);
                    data.files = m.meta;
            
                    var attachment = new Attachment(data)
            
                    attachment.pre_type = 'a';
                    attachment.pre_data = [data.event.replace(/<(?:.|\n)*?>/gm, '').length, attachment.image_count, attachment.file_count];
            
                    return attachment;
            
                }
            
                function update_unread() {
            
                    var unread = msg_count - read;
            
                    if (unread > 0 && ui.conversation.bottom && (!t.minimize.value || isPopOut))
                        return mark_as_read();
            
                    var a = $(sc('#msg-alert'));
                    var b = $(sc('.badge'));
            
                    if (unread > 0) {
            
                        var nc = unread + ' new message' + (unread > 1 ? 's' : '')
            
                        if (!ui.conversation.bottom)
                            a.html(render(templates.new_msg_alert, {
                                new_count: nc
                            }));
            
                        b
                            .html(unread)
                            .removeClass(hide)
                            .addClass(sc('bounceIn'))
            
                        if (lm) {
            
                            pop_message(messages[lm])
            
                            // if (!loaded)
                            //     ping()
            
                            lm = null;
                        }
            
            
                    } else {
            
                        a.empty();
            
                        b
                            .addClass(hide)
                            .removeClass(sc('bounceIn'))
            
                    }
            
            
                }
            
                function defer_update_unread() {
            
                    clearTimeout(dUu)
                    dUu = setTimeout(update_unread, 100);
            
                }
            
                function update_msg_count(msg) {
            
                    msg_count = msg.val() || 0;
            
                    //        if (msg_count > read) ping()
            
                    defer_update_unread()
            
                }
            
                function update_read(my_read) {
            
                    read = my_read.val() || 0;
                    defer_update_unread()
            
                }
            
                function bottom_reached() {
            
                    if ((t.minimize.value && !isPopOut) || tab_hidden()) return;
            
                    if (msg_count > read)
                        mark_as_read();
            
                }
            
                function mark_as_read() {
            
                    rf.messages.child('read').child(t.uid.value).set(msg_count);
            
                }
            
                function show_typing(snap) {
            
                    if (snap.val())
                        ui.conversation
                        .append(ui.typing)
                        .scroll_end(hasFocus(), loaded)
                    else
                        ui.typing.detach();
            
                }
            
            
            
            }
            

            
                    function bind_ref_session()
                    {
            
                        var task = $.Deferred();
                        if (ref.session) ref.session.off();
                        if (ref.lobby) ref.lobby.off();
            
                        var sid = t.sid.get()
                        if (!sid)
                          return setTimeout(bind_ref_session, 1000)
            
                        ref.session = fb.child('sessions').child(t.sid.get());
                        ref.lobby = fb.child('lobby').child(t.sid.get())
            
                        ref.session.on('value',function(snap){
                            var v = snap.val();
                            if (!v) return;
                            if (!v.geoip) return;
                            //only trigger this function once, but wait for v to have value
                            ref.session.off();
            
                            session = v;
                            if (!v.state)
                            {
            
                                var w = t.widget.value;
            
                                var o = {
                                    state: 1
                                    , view_state: 1
                                    , teams: t.teams.value
                                    , updated_at: fb_time
                                    , visitor_status: 'online'
                                    , widget_id : widget_id
                                    , widget_name : w.name
                                }
            
                                if (t.minimize.value || do_prechat())
                                    o.view_state = 1;
            
                                ui.conversation
                                    .empty();
            
                                o.meta = (meta && meta.assigned) ? meta : { assigned: make_name() }
            
                                $.extend(session,o);
            
                                ref.session.update(o);
            
                            }
            
                            //add current state
                            t.state.set(session.state);
                            t.rate.set(session.rate);
            
                            $.extend(meta,session.meta)
            
                            //add session listeners here
            
                            ref.session.child('load_state').on('value',function(new_snap){
            
                                var nv = new_snap.val()
            
                                if (nv)
                                    {
            
                                        $(sc('.module'), ui.box).addClass(hide);
            
                                        ui.conversation
                                        .empty()
                                        .append(render(templates.event, {
                                            time: get_time(new Date().getTime())
                                            ,event: t.widget.value.language.starting
                                            }))
                                        .removeClass(hide);
            
                                    }
            
                            })
            
                            if (session.state > 1 && session.state < 4) {
            
                                ref.lobby.child('updated_at').set(fb_time);
                                ref.lobby.child('updated_at').on('value',function(new_snap)
                                {
            
                                    ref.session.child('updated_at').set(fb_time)
                                    ref.session.child('updated_at').onDisconnect(fb_time)
            
                                    var nv = new_snap.val();
            
                                    if (!nv)
                                        ref.lobby.child('updated_at').set(fb_time);
            
                                })
            
                            }
            
                            ref.session.child('state').on('value', function(new_snap){
            
                                var nv = new_snap.val();
            
                                if (nv && nv > 3) {
                                    ref.lobby.child('updated_at').off()
                                    ref.session.child('updated_at').onDisconnect().cancel()
                                }
            
            
                            })
            
                            ref.session.child('visitor_status').on('value',function(new_snap)
                            {
            
                                var nv = new_snap.val();
            
                                ref.session.child('visitor_status').onDisconnect().set('away');
            
                                if (nv == 'away' && session.view_state < 4)
                                    ref.session.child('visitor_status').set('online');
            
            
                            })
            
                            ref.session.child('agent').on('value', function(new_snap){
                                var nv = new_snap.val()
            
                                if (nv)
                                    update_agent(nv)
            
                            })
            
                            ref.session.on('value', function(new_snap){
            
                                var nv = new_snap.val();
                                var ov = session;
            
                                if (!nv) return;
            
                                if (changed(nv,ov,'view_state') || (nv.view_state != t.view_state.value))
                                    {
                                        t.view_state.set(nv.view_state);
                                        load_state();
                                    }
            
                                if (changed(nv,ov,'meta'))
                                    {
                                        $.extend(meta,nv.meta)
                                        update_form();
                                    }
            
                                if (changed(nv,ov,'state') || (nv.state != t.state.value))
                                    t.state.set(nv.state);
            
                                session = nv;
            
                            });
            
            
                            //if form visible
            
                            if (session.view_state == 1 && ui.prechat)
                            for (var k in meta)
                                if (k != 'message')
                                $('[name=' + k + ']', ui.prechat).val(meta[k]);
            
                            task.resolve()
                            // Bugsnag.leaveBreadcrumb('Bound Session');
            
                        })
            
                        return task.promise()
            
                    }
            
                    var agent_m = {};
            
                    function update_agent(i)
                    {
            
            
                            for (var m in agent_m) {
                                fb.child('agents').child(m).off('value',agent_m[m])
                                delete agent_m[m]
                            }
            
                            agent_m[i] = fb.child('agents').child(i).on('value',function(n){
                                var v = n.val();
                                var k = n.key();
                                var a = {};
            
                                a.key = k;
            
                                a.name = v.nickname;
                                a.avatar = v.avatar;
                                a.title = v.title;
                                t.agent.set(a);
                                update_header('agent');
                            });
            
                    }
            
                    function make_name()
                    {
            
                        var c = "0123456789abcdefghiklmnopqrstuvwxyz";
                        var s = '';
                        for (var i = 0; i < 4; i++) {
                            var r = make_num(10, c.length - 1);
                            s += c.substring(r, r + 1);
                        }
            
                        for (var i = 0; i < 4; i++) {
                            var r = make_num(0, c.length - 1);
                            s += c.substring(r, r + 1);
                        }
            
                        return s.toUpperCase();
            
                    }
            
                    function make_num(min, max)
                    {
                        return Math.floor(Math.random() * (max - min + 1) + min);
                    }
            

            function bind_ref_visitor() {
            
              var task = $.Deferred();
              var uid = t.uid.get();
            
              // if (console && console.log)
              //   console.log(uid,t)
            
              if (!uid)
                return setTimeout(bind_ref_visitor, 1000)
            
              ref.visitor = fb.child('visitors').child(uid);
            
              ref.visitor.on('value', function(snap) {
            
                var v = snap.val();
            
                if (!v) {
                  return;
                }
            
                visitor = v;
            
                if (!v.token) {
            
                  var o = {
                    domain: location.hostname,
                    sessions: {},
                    token: t.token.value,
                    updated_at: fb_time,
                    widget_id: widget_id,
                    window_minimize: true,
                  };
            
                  o.sessions[t.sid.value] = fb_time;
            
                  t.minimize.set(true);
            
                  $.extend(visitor, o);
                  ref.visitor.update(o);
            
                }
            
                //only trigger once until visitor has value
                ref.visitor.off();
            
                ref.visitor.child('session_id').on('value', function(new_snap) {
            
                  var nv = new_snap.val();
            
                  if (nv && nv != t.sid.value) {
            
                    t.sid.set(nv);
            
                    bind_ref_session()
                      .then(bind_ref_messages)
                      .then(bind_ref_history);
            
                  }
            
                });
            
                ref.visitor.child('banned').on('value', function(new_snap) {
            
                  var nv = new_snap.val()
                  t.banned.set(nv);
                  if (nv)
                    set_minimize()
            
                })
            
                ref.visitor.child('window_minimize').on('value', function(new_snap) {
            
                  var nv = new_snap.val();
                  var ov = t.minimize.value;
                  if (changed(nv, ov)) {
                    t.minimize.set(nv);
                    set_minimize(nv);
                    visitor.window_minimize = nv;
            
                    if (!nv) $.event.trigger({ type: 'swaychat-maximize' })
            
                  }
            
                });
            
                ref.visitor.child('hidden').on('value', function(new_snap) {
            
                  var nv = new_snap.val();
                  var ov = t.hidden.value;
                  if (changed(nv, ov)) {
                    t.hidden.set(nv);
                    set_minimize(t.minimize.value);
                  }
            
                });
            
                ref.visitor.child('popout').on('value', function(new_snap) {
            
                  var v = new_snap.val();
            
                  if (!ui.box) return;
            
                  t.popout.set(v);
            
                  if (isPopOut && !v) {
                    v = true;
                    ref.visitor.child('popout').onDisconnect().set(false);
                    ref.visitor.child('popout').set(true);
                  } else if (!isPopOut && v) {
                    ui.box.addClass(hide);
                    ref.visitor.child('window_minimize').set(true);
                    if (pop_timer) clearTimeout(pop_timer);
                  } else if (!v) {
                    ui.box.removeClass(hide);
                    set_minimize(t.minimize.value);
                  }
            
                });
            
                task.resolve();
                // Bugsnag.leaveBreadcrumb('Bound Visitor');
            
              });
            
              return task.promise();
            }
            
            function is_hide_expire(force) {
            
              var d = ((new Date()) - t.hidden.value) / (1000 * 60 * 60);
            
              if (d > 1 || force) {
                if (ref.visitor)
                  ref.visitor.child('hidden').set(false);
            
                return true;
              }
            
              return false;
            }
            
            var vp = $('meta[name=viewport]');
            var vp_c = vp ? vp.attr('content') : '';
            var is_mobile = ((/Mobile|iPhone|iPod|BlackBerry|Windows Phone/i).test(navigator.userAgent || navigator.vendor || window.opera) ? true : false);
            
            function set_viewport(set) {
            
              if (!is_mobile) {
                return;
              }
            
              if (vp.length) {
            
                if (set) {
                  vp.attr('content', 'width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0');
                } else {
                  vp.attr('content', vp_c);
                }
            
              } else {
            
                if (set) {
                  if (!$('meta.swaychat').length) {
                    $('head').prepend(templates.viewport);
                  }
                } else {
                  $('meta.swaychat')
                    .attr('content', 'width=1024, maximum-scale=1.0')
                    .remove();
                }
            
              }
            
              if (set)
                $('body').css({ 'min-width': '100%', 'overflow': 'hidden' })
              else
                $('body').css({ 'min-width': '', 'overflow': '' })
            
            }
            
            var m_state;
            var lh;
            var wh = $(window).height();
            
            var sHo;
            
            function do_height(i) {
            
              clearTimeout(sHo);
              sHo = setTimeout(set_height, i ? i : 100);
            
            }
            
            function set_height() {
            
              if (!ui && !ui.container) {
                return;
              }
            
              if (m_state !== false) {
                return;
              }
            
              var nh = 0;
            
              var sp;
            
              if (t.view_state.value == 1) {
            
                ui.box.addClass(sc('pre-chat'));
            
                var el = $(sc('.form'), ui.box);
                var up = ui.prechat.parent();
                sp = ui.container.find(sc('.powered:visible'));
                var et = el.position().top + ui.prechat.get(0).scrollTop;
                var eh = el.height() + $(sc('.chathead'), ui.box).outerHeight();
                var eb = 32;
                var sph = sp.outerHeight();
            
                //console.log(et,eh,sph);
            
                if (eh)
                  nh = et + eh + sph;
            
                if (nh > (wh - eb))
                  nh = wh - (eb * 2);
            
              } else {
            
                sp = ui.modal.find(sc('.powered'));
            
                if (wh < 418)
                  nh = wh;
                else
                  nh = '';
            
              }
            
              if (nh && nh == (wh - (eb * 2))) {
                sp.addClass(sc('powered-scroll'));
                ui.prechat.addClass(sc('prechat-scroll'));
              } else {
                sp.removeClass(sc('powered-scroll'));
                ui.prechat.removeClass(sc('prechat-scroll'));
              }
            
              ui.container
                .height(nh)
                .css('max-height', wh - (eb * 2));
                ;
            
              lh = nh;
            
            }
            
            var smTo;
            
            function set_minimize(v) {
            
              if (isPopOut) {
                v = false;
              }
            
              m_state = v;
            
              var el = ui.container;
              var wgt = t.widget.get();
            
              var sm = wgt.theme.startup_mode;
              var ho = wgt.options ? wgt.options.offline_form.hideoffline : false;
            
              var u = ui.box;
              var max = sc('maximize-window');
              var min = sc('minimize-window');
              var bbc = sc('bubblehead');
              var bbm = sc('bubblehead-max');
              var is_hidden = p.hidden || $('#swaychat').data('hidden') || t.banned.get();
            
              if (!u) {
                return;
              }
            
              //hide if
              //  widget is hidden by user and not expired || widget is config to hide when offline and offline || widget is popped and this is not the popout
              if (is_hidden || (t.hidden.value && !isPopOut && !is_hide_expire()) || (ho && !isPopOut && !online() && t.view_state.value < 2) || (t.popout.value && !isPopOut)) {
            
                //u.addClass(hide);
                ui.bubblehead.addClass(hide);
                el.addClass(hide);
            
                return;
              }
            
              if (v) {
                // set
            
                set_viewport(false);
            
                el
                  .height('')
                  .css('max-height', '')
                  .removeClass(max)
                  .addClass(min);
            
                if (sm == 'link' && t.view_state.value > 1) {
                  sm = 'minimize';
                }
            
                if (sm != 'bubblehead') {
                  u.removeClass(bbc);
                  ui.bubblehead.addClass(hide);
                }
            
                if (sm != 'link' && el.hasClass(hide)) {
                  el.removeClass(hide);
                }
            
                switch (sm) {
                  case 'bubblehead':
            
                    u.addClass(bbc);
            
                    //el.addClass(hide);
                    ui.bubblehead.removeClass(hide);
                    break;
                  case 'link':
                    if (!is_loaded) {
                      el.addClass(hide);
                    }
            
                    clearTimeout(smTo);
                    smTo = setTimeout(function() {
                      el.addClass(sc('zoomOut'));
                    }, 400);
            
                    break;
            
                  default:
                    u.removeClass(bbc);
                    el.addClass(sc('zoomIn'))
                      .removeClass(sc('zoomOut'));
                }
            
              } else {
            
                set_viewport(true);
            
                do_height();
            
                u.removeClass(bbc);
            
                el
                  .removeClass(hide)
                  .removeClass(bbm)
                  .removeClass(min)
                  .removeClass(sc('zoomOut'))
                  .addClass(max);
            
                ui.bubblehead.addClass(hide);
            
                if (sm == 'bubblehead')
                  el.addClass(bbm);
            
                 do_height(10);
            
            
              }
            
            }
            

            
            function bind_ref_widget() {
            
              var task = $.Deferred();
            
              ref.widget = fb.child('widgets').child(widget_id);
            
              ref.widget.once('value', function (snap) {
                var v = snap.val();
                if (v) {
                  // set initial settings
                  t.widget.set(v);
            
                  // detect if first install and notify server
                  if (!v.first_install && (location.href.indexOf('swaychat.com/testdrive-iframe') < 0)) {
                      ref.widget.child('first_install').set(fb_time).then(function(){
                          _NotifyInstall.push({
                              created: fb_time,
                              org_id: org_id,
                              widget_name: v.name,
                              widget_id: widget_id,
                              url: location.href
                          })
                      })
                  }
            
                  update_teams();
            
                  // create listeners for changes
                  ref.widget.on('value', function (new_snap) {
            
                    var nv = new_snap.val();
                    var ov = t.widget.value;
            
                    t.widget.set(nv);
                    // resolve
                    task.resolve();
                    
                    if (!ov)
                      return;
            
                    if (changed(nv, ov, 'theme')) {
                      load_theme();
                    }
            
                    if (changed(nv, ov, 'settings')) {
                      load_settings();
                    }
            
                    if (changed(nv, ov, 'options') || changed(nv, ov, 'onlineAgents')) {
                      update_header('prechat');
                      update_form();
                      set_minimize(t.minimize.value);
                    }
            
                    if (changed(nv, ov, 'teams')) {
                      update_teams();
                    }
            
                    if (changed(nv, ov, 'language')) {
                      update_lang();
                    }
            
            
                  });
            
                } else {
                  task.reject();
                }
            
              });
            
              // Bugsnag.leaveBreadcrumb('Bound Widget');
              return task.promise();
            
            }
            
            function update_lang() {
              var lang = $.extend(def_lang,t.widget.value.language);
              $(sc('#message-text')).attr('placeholder', lang.reply_message);
              $(sc('.send-button') + ' button').val(lang.send).text(lang.send);
              $(sc('.text-mute-chat')).text(lang.disable_sound);
              $(sc('.text-unmute-chat')).text(lang.enable_sound);
              $(sc('.text-attach-file')).text(lang.attach_file);
              $(sc('.text-end-chat')).text(lang.end_chat);
            
            }
            
            function update_teams() {
            
              var teams = t.widget.value.teams;
            
              for (var i in teams) {
                if (teams_m[i]) {
                  continue;
                }
            
                teams_m[i] = fb.child('teams').child(i).on('value', function (n) {
                  var teams_v = t.teams.get() ? t.teams.value : {};
                  var vl = n.val();
                  var k = n.key();
                  var v = {};
            
                  v.name = vl.name;
                  v.role = 0;
            
                  teams_v[k] = v;
                  t.teams.set(teams_v);
                  update_form();
                });
              }
            
            }
            
            function load_theme() {
            
              var v = t.widget.value.theme;
              if (!v) return;
            
              //apply local css
              ui.theme.text(render(templates.theme, v));
            
              //adjust font color
              ui.container.removeClass(sc('dark light', 'contrast'));
              if (/^#[0-9A-F]{6}$/i.test(v.primary_bg)) {
                ui.container.addClass(sc('contrast-' + get_contrast(v.primary_bg.substr(1))));
              }
            
              //toggle brand
              if (v.hide_brand == 'none') {
                ui.container.addClass(sc('disabled-brand'));
              } else {
                ui.container.removeClass(sc('disabled-brand'));
              }
            
              //set position
              $(ui.box)
              .removeClass(sc('top-left bottom-left bottom-right top-right', 'chatbox-position'))
              .addClass(sc('chatbox-position-' + v.position));
            
              //set minimize and startup mode
              set_minimize(t.minimize.value);
            
              //update image src
              update_header('prechat');
            
              var upb = $(sc('.attach-files'));
              if (v.upload) {
                upb.removeClass(hide);
              } else {
                upb.addClass(hide);
              }
            
            }
            
            function load_settings() {
            
              var s = t.widget.value.settings;
              if (!s) return;
            
              var snd = $(sc('.sound'));
              if (s.sounds) {
                snd.removeClass(hide);
              } else {
                snd.addClass(hide);
              }
            
            }
            

            function Reactions() {
            
                var reactions = {
                    rules: {},
                    actions: {},
                };
            
                var is_hidden = p.hidden || $('#swaychat').data('hidden') || t.banned.get();
                reactions.rules.history = {
                    pageCount: function(cond) {
                        var task = $.Deferred();
                
                        //            console.log('page_count',page_count)
                
                        if (eval(page_count + cond.equate + cond.value))
                            task.resolve(true)
                        else
                            task.reject()
                
                        return task.promise()
                    }
                }
                
            
                reactions.rules.page = {
                    urlMatch: function(cond) {
                
                        var task = $.Deferred();
                        var url = location.href + '';
                
                //        console.log(cond.equate.replace('{value}', cond.value) + '.test(url)',eval(cond.equate.replace('{value}', cond.value) + '.test(url)'))
                
                        if (cond.equate && eval(cond.equate.replace('{value}', cond.value) + '.test(url)'))
                            task.resolve(true)
                        else
                            task.reject()
                
                        return task.promise()
                    },
                    urlEquate: function(cond) {
                
                        var task = $.Deferred();
                        var url = location.href + '';
                
                        if (cond.equate && eval("'" + url + "'" + cond.equate + "'" + cond.value + "'"))
                            task.resolve(true)
                        else
                            task.reject()
                
                        return task.promise()
                    },
                
                
                
                
                
                }
                
            
                reactions.rules.session = {
                    length: function(cond) {
                        var task = $.Deferred();
                
                        fb.child('sessions').child(t.sid.get()).child('created_at').once('value', function(snap) {
                
                            var len = Math.floor((new Date().getTime() - snap.val()) / 1000);
                
                            //                console.log('session_length',len)
                
                            if (eval(len + cond.equate + cond.value))
                                task.resolve(true)
                            else
                                task.reject()
                
                        })
                
                        return task.promise()
                    },
                    ip: function(cond) {
                
                        var task = $.Deferred();
                
                        fb.child('sessions').child(t.sid.get()).child('geoip/ip').once('value', function(snap) {
                
                            var ip = snap.val();
                
                            if (ip && eval("'" + ip + "'" + cond.equate + "'" + cond.value + "'"))
                                task.resolve(true)
                            else
                                task.reject()
                
                        })
                
                        return task.promise()
                
                
                    }
                
                }
                
            
                reactions.actions.messages = {
                    sendToVisitor: function(data) {
                
                        var task = $.Deferred();
                
                        if (data.value) {
                
                            var msg = {
                                message: data.value,
                                time: get_time(new Date().getTime())
                            }
                
                            var after = data.after ? data.after * 1000 : 0;
                
                            setTimeout(function() {
                                pop_message(msg)
                            }, after)
                
                            task.resolve()
                
                        } else
                            task.reject()
                
                        return task.promise()
                
                    },
                    grabber: function (data) {
                
                        var task = $.Deferred();
                
                        var after = data.after ? data.after * 1000 : 0;
                
                        setTimeout(function() {
                            ui.grabber.show(data)
                        }, after)
                
                        task.resolve()
                
                        return task.promise()
                
                    },
                
                }
                
            
            
            
                return {
                    load: load
                }
            
                function load() {
            
                    connect().then(process)
            
                }
            
                function connect() {
            
                    return fb.child('widgets').child(widget_id).child('reactions').once('value', function(snap) {
                        reactions.data = snap.val()
                    })
            
                }
            
                function process() {
            
                    if (reactions.data)
                        for (var a in reactions.data) {
            
                            var ra = reactions.data[a];
                            var whn = ra.when == 'online' ? true : false;
            
                            if (!is_hidden && ra.enabled && (whn == online()) && ra.view_state == t.view_state.get())
                                test(ra.if.rules)
                                .then(function() {
            
                                    var all = ra.if.type == 'and' ? true : false;
                                    var task = $.Deferred();
                                    var pass = 0;
            
                                    for (var b in arguments)
                                        if (arguments[b])
                                            pass += 1;
            
                                    if (
                                        arguments.length &&
                                        (
                                            (all && pass == arguments.length) ||
                                            (!all && pass > 0)
                                        )
                                    )
                                        task.resolve()
                                    else
                                        task.reject()
            
                                    return task.promise();
            
                                })
                                .then(function() {
            
                                    var task = $.Deferred();
            
                                    if (ra.then.per) {
            
                                        var n = ra.then.per + 's';
                                        var nid = ra.then.per == 'visitor' ? t.uid.get() : t.sid.get();
            
                                        if (ra.then.per != 'page')
                                        fb.child(n).child(nid).child('reactions_done').child(a).once('value', function(snap) {
            
                                            if (!snap.val())
                                                reactWith(this.actions)
                                                .then(function() {
                                                    snap.ref().set(Firebase.ServerValue.TIMESTAMP)
                                                    task.resolve();
                                                })
                                            else
                                                task.resolve();
            
                                        }, ra.then)
                                        else {
            
                                            reactWith(ra.then.actions)
                                            .then(function() {
                                                task.resolve();
                                            })
            
                                        }
            
                                    }
                                    else
                                        task.reject()
            
                                    return task.promise();
            
            
                                })
                                // .done(function(){
                                //
                                //     console.log('success', a)
                                //
                                // })
                                // .fail(function(e) {
                                //
                                //     console.log('fail', a)
                                //
                                // })
            
                        }
            
            
                }
            
            
                function reactWith(actions) {
            
                    var acts = [];
            
                    for (var i in actions) {
            
                        var act = actions[i];
                        var a = getProp(reactions, act.type);
            
                        if (typeof a == 'function')
                            acts.push(a(act))
                        else
                            acts.push(false)
                    }
            
                    return $.when.apply($, acts)
            
                }
            
            
                function test(rules) {
            
                    var tests = [];
            
                    for (var i in rules) {
            
                        var rule = rules[i];
                        var r = getProp(reactions, rule.type);
            
                        if (typeof r == 'function')
                            tests.push(r(rule))
                        else
                            tests.push(false)
            
                    }
            
                    return $.when.apply($, tests);
            
                }
            
                function getProp(obj, propString) {
                    if (!propString)
                        return obj;
            
                    var prop, props = propString.split('.');
            
                    for (var i = 0, iLen = props.length - 1; i < iLen; i++) {
                        prop = props[i];
            
                        var candidate = obj[prop];
                        if (candidate !== undefined) {
                            obj = candidate;
                        } else {
                            break;
                        }
                    }
                    return obj[props[i]];
                }
            
            
            
            }
            

            
            function Advance_Rating() {
            
                var box = $('<div />');
                var active_q = ''
                var qs = {};
            
                return {
                    load: load,
                    unload: unload,
                }
            
                function load() {
            
                    var settings = t.widget.value.settings.advance_rating;
                    var data = $.extend({},settings.language)
            
                    data.nav = '';
                    data.qs = '';
            
                    for (var i = 0; i < settings.order.length; i++) {
            
                        var key = settings.order[i]
                        var dt = $.extend({key:key},settings.qs[key]);
            
                        if (!dt.visible) continue;
            
                        if (!active_q) active_q = key;
            
                        qs[key] = dt;
            
                        data.nav += '<li data-key="'+key+'"><span>'+i+'</span></li>';
                        data.qs += render(templates.rate_advance_q,dt)
                    }
            
                    if (!active_q)
                        active_q = 'comment';
                        
                    if (t.view_state.get() == 4)
                        data.submit = render(templates.rate_advance_submit_2,data);
                    else
                        data.submit = render(templates.rate_advance_submit_1,data);
                        
            
                    box.html(render(templates.rate_advance,data))
                    ui.modal.append(box)
            
                    box.on('submit','form', submit)
                    box.on('click',sc('.page-indicator')+' li', i_click)
                    box.on('click',sc('.arrow-next'), next)
                    box.on('click',sc('.arrow-previous'), back)
                    box.on('click','input[type=radio]', select)
                    box.on('change','textarea', change_textarea)
            
                    //activate first q
                    set_active(active_q);
                }
            
                function unload() {
            
                    active_q = ''
                    qs = {};
            
                    box.off('submit','form', submit)
                    box.off('click',sc('.page-indicator')+' li', i_click)
                    box.off('click',sc('.arrow-next'), next)
                    box.off('click',sc('.arrow-previous'), back)
                    box.off('click','input[type=radio]', select)
                    box.off('change','textarea', change_textarea)
            
                    box.remove()
                    ui.rating = null;
                }
            
                function submit(e) {
            
                    e.preventDefault()
            
                    var data = {'filled':false, sum: 0, count: 0, ave: 0, scores:{}}
            
                    for (var i in qs) {
            
                        var v = box.find('form input[name='+i+']:checked').val()
            
                        if (!v && qs[i].required)
                            return set_active(i)
            
                        v = v ? parseInt(v) : 0;
            
                        data.scores[i] = v;
                        data.sum += v;
                        data.count += 1;
                        data.filled = true;
            
                    }
            
                    if (data.count) {
            
                        data.ave = data.sum / data.count;
            
                        push_message({
                            rate: data.ave,
                            type: 1,
                            subtype: 11,
                        });
            
            
                    }
            
                    //save data even if unfilled
                    ref.session.child('advance_rate').set(data)
                    
                    t.rate.set(true)
            
                    var ta = $('textarea[name=comment]', box);
            
                    if (ta.val()) {
            
                        var comment = ta.val().trim().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
            
                        ta.val('');
            
                        if (comment) {
                            ref.session.child('comment').set(comment);
            
                            push_message({
                                message: comment,
                                type: 1,
                                subtype: 8,
                            });
                        }
            
                    }
            
                    do_end()
            
                }
            
                function set_active(q) {
            
                    box.find(sc('.advanced-rating-item:visible')).hide()
                    box.find(sc('#advanced-rating-'+q)).removeClass(sc('zoomOut')).show()
                    box.find(sc('.indicator-active')).removeClass(sc('indicator-active'))
                    box.find('li[data-key='+q+']').addClass(sc('indicator-active'))
            
                    if (q == 'comment')
                        box.find('textarea:visible').trigger('focus')
            
                    active_q = q;
            
                }
            
                function i_click(e) {
            
                    set_active($(this).data('key'))
            
                }
            
                function next() {
            
                    var n = box.find('li[data-key='+active_q+']').next()
                    var key;
            
                    if (!n.length)
                        n = box.find(sc('.page-indicator')+' li:first')
            
                    key = n.data('key');
            
                    set_active(key)
            
                }
            
                function back() {
            
                    var n = box.find('li[data-key='+active_q+']').prev()
                    var key;
            
                    if (!n.length)
                        n = box.find(sc('.page-indicator')+' li:last')
            
                    key = n.data('key');
            
                    set_active(key)
            
                }
            
                function select() {
            
                    box.find('li[data-key='+this.name+']').addClass(sc('indicator-done'))
            
                    if (active_q != 'comment')
                        setTimeout(next, 300)
            
                }
            
                function change_textarea() {
            
                    if ($(this).val())
                        box.find('li[data-key=comment]').addClass(sc('indicator-done'))
                    else
                        box.find('li[data-key=comment]').removeClass(sc('indicator-done'))
            
                }
            
            }
            

            
            function Simple_Rating() {
            
                var box = $('<div />',{class : sc('row')});
                var sel = sc('rate-selected');
                var bIn = sc('rate-bounceIn');
            
                return {
                    load: load,
                    unload: unload,
                }
            
                function load() {
            
                    var r = t.widget.value.language.ratings;
                    var rate = t.rate.value;
                    var lang = $.extend(def_lang,t.widget.value.language);
            
                    var data = {
                        great: lang.ratings[2].label,
                        ok: lang.ratings[1].label,
                        bad: lang.ratings[-1].label,
                    };
            
                    $.extend(data,lang);
            
                    if (rate != null)
                        data['r' + rate] = sel + ' ' + bIn;
            
                    if (t.view_state.get() == 4)
                        data.submit = templates.rated_modal_submit_2;
                    else
                        data.submit = templates.rated_modal_submit_1;
            
                    data.submit = render(data.submit,lang)
                    data.rates = render(templates.rates, data);
                    box.html(render(templates.rate_modal,data))
                    ui.modal.append(box)
            
                    setTimeout(function () {
                        $('.' + bIn, ui.box).removeClass(bIn);
                    }, 300);
            
                    box.on('click',sc('.rate') + ' li',click_rate)
                    box.on('click', sc('.button-end'), submit)
            
            
                }
            
                function unload() {
            
                    box.off('click',sc('.rate') + ' li',click_rate)
                    box.off('click', sc('.button-end'), submit)
            
                    box.remove()
                    ui.rating = null;
                }
            
            
                function click_rate() {
                    var el = $(this);
                    var rating = parseInt(el.data('rate'));
            
                    t.rate.set(rating);
            
                    el.addClass(sel).siblings().removeClass(sel);
            
                    box.find('textarea').trigger('focus');
            
                };
            
                function submit() {
            
                        var ta = $('textarea[name=comment]', box);
                        var rating = t.rate.get();
            
                        if (rating) {
            
                            ref.session.child('rate').set(rating);
            
                            push_message({
                                rate: rating,
                                type: 1,
                                subtype: 7,
                            });
            
                        }
            
                        if (ta.val()) {
            
                            var comment = ta.val().trim().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
            
                            ta.val('');
            
                            if (comment) {
                                ref.session.child('comment').set(comment);
            
                                push_message({
                                    message: comment,
                                    type: 1,
                                    subtype: 8,
                                });
                            }
            
                        }
            
                        do_end()
                }
            
            }
            

            
            
            function No_Rating() {
            
                var box = $('<div />');
            
                return {
                    load: load,
                    unload: unload
                }
            
                function load() {
            
                    var lang = $.extend(def_lang,t.widget.value.language);
            
                    box.html(render(templates.no_rate_modal,lang));
                    ui.modal.append(box)
            
                    box.on('click', sc('.button-end'), do_end)
            
                }
            
                function unload() {
            
                    box.off('click', sc('.button-end'), do_end)
            
                    box.remove()
                    ui.rating = null;
                }
            
            }
            



            function bind() {

                if ((/bingpreview/ig).test(navigator.userAgent) || (ie && ie < 9))
                    return;

                init_fs().then(function() {

                    $('body')
                        .on('click', '.SwayChat-Toggle', function(e) {
                            e.preventDefault();
                            toggle();
                        })
                        .on('click', '.SwayChat-Popout', function(e) {
                            e.preventDefault();
                            popout();
                        })

                    if (isPopOut || t.token.get())
                        return init()

                    $('body').on('mouseenter mousemove touchstart', init);

                    if (tab_hidden())
                        $(window).on('focus visibilitychange', init)

                    init_timer = setTimeout(init, 1000 * 60 * 2)


                })

            }

            function unbind() {

                $('body').off('mouseenter mousemove touchstart', init);
                $(window).off('focus visibilitychange', init)
                clearTimeout(init_timer)

            }

            function init() {

                if (started)
                    return;

                unbind()

                started = true;
                tried += 1;


                //initialize frame storage
                load_css()
                    .then(function() {

                        //try preload
                        if (t.widget.value && (t.minimize.value || t.view_state.value > 1 || isPopOut || !t.widget.value.reactions)) {
                            build_ui();
                            load_theme();
                            load_settings();
                            load_state();
                        }

                        return true;
                    })
                    .then(request_token)
                    .then(start_listener)
                    .then(fetch_integrations)
                    .then(bind_ref_widget)
                    .then(function() {

                        if (ui.box) return true;

                        build_ui();
                        load_theme();
                        load_settings();

                    })
                    .then(bind_ref_visitor)
                    .then(bind_ref_session)
                    .then(bind_ref_messages)
                    .then(bind_ref_history)
                    .done(function() {

                        if (!is_loaded)
                            load_state();

                        if (isPopOut)
                            return;

                        ui.grabber = new Grabber();
                        ui.reactions = new Reactions().load();

                        if (typeof window.swaychat_api == 'function' && swaychat_api.toString().match('swaychat.set_')) {
                            try {
                                swaychat_api()
                            } catch (e) {

                            }
                        }
                    })
                    .fail(function() {
                        started = false;

                        if (tried < 3)
                            setTimeout(init, retry_delay)
                    });
            }

            function load_css() {

                var task = $.Deferred();

                ui.css = $('<link />', {
                    type: 'text/css',
                    rel: 'stylesheet',
                }).appendTo(document.head);

                ui.theme = $('<style />').appendTo(document.head);

                ui.css.attr('href', cdn + 'themes/default.css');
                ui.css.load(function() {
                    task.resolve();
                });

                return task.promise();

            }

            function init_fs() {

                var task = $.Deferred();

                fs = new frameStorage(org_id + '/' + widget_id, function() {

                    var ls = [
                        'token', 'uid', 'widget', 'minimize', 'popout', 'hidden', 'state', 'rate', 'sid', 'agent', 'teams', 'mute', 'old_state', 'view_state', 'network', 'sq', 'sent_offline','banned'
                    ];

                    for (var i = 0; i < ls.length; i++)
                        t[ls[i]] = new Storage(ls[i], fs);

                    task.resolve();
                });

                return task.promise();

            }

            function request_token() {

                var task = $.Deferred();

                if (!t.token.get()) {
                    var data = {
                        organization_id: org_id,
                        widget_id: widget_id,
                    };

                    var url = api + '/visitor';

                    retry_delay = 1000 * 2;

                    if (t.sid.get()) {
                        url += '/token';
                        data.sid = t.sid.get();
                        data.uid = t.uid.get();
                    }

                    $.ajax({
                            type: 'POST',
                            url: url,
                            data: data,
                            dataType: 'jsonp',
                            //                timeout: 1000*60*3,
                        }).done(function(data) {
                              set_token(data, task)

                        })
                        .fail(function(xhr, textStatus, errorThrown) {

                            // Bugsnag.leaveBreadcrumb('Error Thrown', {
                            //     error: errorThrown
                            // });

                            // if (xhr.responseText)
                            //     Bugsnag.leaveBreadcrumb('Response Text', {
                            //         text: xhr.responseText
                            //     })

                            if (!xhr.getAllResponseHeaders()) {
                                retry_delay = 1000 * 60 * 2;
                            } else {

                                // Bugsnag.leaveBreadcrumb('API Failed', xhr)

                                // if (textStatus == 'parsererror')
                                //     Bugsnag.notify('API Visitor Failed', 'Parse Error', {
                                //         xhr: xhr
                                //     })
                                // else
                                //     Bugsnag.notify('API Visitor Failed', 'Failed XHR v7', {
                                //         error: {
                                //             status: textStatus,
                                //             error: errorThrown,
                                //             headers: xhr.getAllResponseHeaders ? xhr.getAllResponseHeaders() : '',
                                //             content: xhr.responseText,
                                //             data: data,
                                //         }
                                //     })

                                //no retries since API is obviously blocked
                                tried = 3;

                            }

                            task.reject();
                        });

                } else {
                    task.resolve();
                }

                return task.promise()

            }

            function set_token(o, task) {
                if (!o.data) {
                    task.reject();
                    return;
                }

                if (!t.token.get()) {

                    // Bugsnag.leaveBreadcrumb('New Sid ' + o.data.session_id)

                    t.token.set(o.data.token);

                    if (o.data.uid)
                        t.uid.set(o.data.uid);

                    if (o.data.session_id)
                        t.sid.set(o.data.session_id);

                } else {

                    // Bugsnag.leaveBreadcrumb('Token was already set');

                    var data = {
                        organization_id: org_id,
                        keep_id: t.uid.value,
                        revoke_id: o.data.uid,
                        revoke_sid: o.data.session_id,
                    };

                    $.ajax({
                        type: 'POST',
                        url: api + '/visitor/revoke',
                        data: data,
                    });

                }

                  task.resolve();

            }


            function start_listener() {


                var task = $.Deferred();

                auth(task);

                return task.promise();

            }

            function auth(task) {

                var token = t.token.get();
                //        if (tried<2) token = '1';

                fb = new Firebase(fb_url + '/' + org_id);

                // Bugsnag.leaveBreadcrumb('Auth Started');

                if (token && token.length > 50)
                    fb.authWithCustomToken(token, function(error, info) {

                        //if error request for a new token
                        if (error) {

                            // Bugsnag.leaveBreadcrumb('Auth Failed');
                            // if (tried >= 2)
                            //     Bugsnag.notify("Auth Failed", "v3", {
                            //         error: {
                            //             error_msg: error,
                            //             token: token,
                            //             sid: t.sid.get(),
                            //         }
                            //     })
                            t.token.set('');
                            task.reject();

                        } else {

                            // Bugsnag.leaveBreadcrumb('Auth Success');

                            _NotifyService = _NotifyService || new SwaychatNotifyService(fb);
                            _RoundRobin = new Firebase(fb_url + '/' + 'round_robin')
                            _NotifyInstall = new Firebase(fb_url + '/' + 'notify_install')
                            _Integrations = new Firebase(fb_url + '/' + 'integration_messages')

                            task.resolve();

                        }

                    })
                else {

                    // Bugsnag.leaveBreadcrumb("No valid token", {
                    //     token: token
                    // })
                    task.reject();

                }

            }

            // fetch org integrations
            function fetch_integrations() {
                var task = $.Deferred();

                fb.child('integrations').on('value', function(snap) {
                    orgIntegrations = undefined;
                    hasIntegrations = false;

                    if (snap.exists()) {
                        var v = snap.val();

                        // integrations might not have a value, do not reject
                        if (v) {
                            orgIntegrations = v;

                            if (orgIntegrations) {
                                for (var i in orgIntegrations) {
                                    if (orgIntegrations[i]) {
                                        hasIntegrations = true;
                                        break;
                                    }
                                }
                            }

                            v = null;
                        }
                    }

                    if (task) {
                        task.resolve();
                        task = null;
                    }
                });

                return task.promise();
            }

            function online() {
                var w = t.widget.value;
                if (w && w.onlineAgentsList) {
                    for (var agent in w.onlineAgentsList) {
                        if (w.onlineAgentsList[agent]) {
                            return true;
                        }
                    }
                } else {
                    return false;
                }
            }

            function do_prechat() {
                var w = t.widget.value;
                return (w.options[(online() ? 'online' : 'offline') + '_form'].prechat)
            }

            function changed(obj1, obj2, attr) {
                var a = attr && obj1[attr] ? obj1[attr] : obj1;
                var b = attr && obj2[attr] ? obj2[attr] : obj2;
                return (JSON.stringify(a) != JSON.stringify(b))
            }

            function build_ui() {

                if (ui.box) return true;

                ui.box = $('<div />');

                var w = ui.box.get(0);

                w.id = sc('chat-widget');
                w.className = w.id;
                w.style.display = "none";

                $('body').append(w);

                var data = $.extend(def_lang, t.widget.value.language);
                data.time = get_time(new Date().getTime());

                $(w).append(render(templates.chatbox, data));

                ui.form = $('#swaychat-message-reply', w);
                ui.container = $(sc('.chatbox-container'), w);
                ui.conversation = $(sc('#conversation'), w);
                ui.message_box = $(sc('#message-box'), w);
                ui.prechat = $(sc('#prechat-form'), w);
                ui.prechat_box = $(sc('#prechat-form-wrapper'), w)
                ui.modal = $(sc('#modal'), w);
                ui.bubblehead = $(sc('#bubble-head'), w);
                ui.notify = $(sc('#notify'), w);
                ui.lightbox = $(sc('.lightbox'), w);
                ui.upload = $(sc('.upload'), w)
                ui.uploader = $(sc('#uploadfile'), w)

                try {
                    ui.audio = [new Audio(cdn + 'sounds/blop.mp3'), new Audio(cdn + 'sounds/woosh.mp3')];
                } catch (err) {
                    ui.audio = [];
                }

                p.ui = ui;

                update_header('prechat');
                update_header('agent');
                update_form();
                bind_ui();

                preload = new Preload();
                preload.load()

                ui.reply = new Reply()
                // Bugsnag.leaveBreadcrumb('Built UI');

            }

            var resizeTimer;
            var bound_ui = false;

            function bind_ui() {
                
                    ui.box.on('click', sc('#msg-alert')+' a', function(e){
                
                        e.preventDefault();
                        ui.conversation.scroll_end(true);
                
                    })
                
                    //scroll
                
                    var cbr;
                    var pst = 0;
                
                    ui.conversation.bottom = true;
                
                    ui.conversation.on('scroll', function (e)
                    {
                        var st = this.scrollTop + this.clientHeight;
                        var sh = this.scrollHeight;
                        ui.conversation.bottom = ( st >= sh - 30 );
                
                        if (st >= sh-30 && st > pst)
                            defer_chat_bottom_reached()
                
                        pst = st;
                
                    });
                
                    ui.conversation.scroll_top = function() {
                        ui.conversation.get(0).scrollTop = 0;
                    }
                
                    ui.conversation.scroll_end = function(override, loaded) {
                
                
                        if (!ui.conversation.bottom && !override) return;
                
                        if (!hasFocus() && loaded) {
                                ui.conversation.bottom = false;
                                return;
                        }
                
                        if (ui.conversation.dSo) clearTimeout(ui.conversation.dSo);
                        ui.conversation.dSo = setTimeout(scroll_end, 100);
                
                    }
                
                    ui.conversation.scroll_reset = function() {
                
                        clearTimeout(ui.conversation.dSo);
                
                        ui.conversation.bottom = true;
                
                    }
                
                    function scroll_end(){
                
                        var el = ui.conversation.get(0);
                        if (!el) return;
                
                        el.scrollTop = el.scrollHeight;
                
                        defer_chat_bottom_reached()
                
                    }
                
                    function defer_chat_bottom_reached(){
                
                        clearTimeout(cbr);
                        cbr = setTimeout(chat_bottom_reached,100);
                
                    }
                
                    function chat_bottom_reached(){
                
                            $.event.trigger({
                                type: "swaychat_bottom_reached"
                            })
                
                    }
                

                
                ui.box.on('click', sc('#more'), function (e)
                {
                  if (!session) return;
                  e.stopPropagation();
                  $(sc('#dropdown'), ui.box).toggleClass(hide);
                });
                
                $('body').on('click', function ()
                {
                  $(sc('#dropdown'), ui.box).addClass(hide);
                });
                
                ui.box.on('click', sc('.sound'), function (e)
                {
                  e.stopPropagation();
                  $(this)
                      .toggleClass(sc('sound-on sound-off'))
                      ;
                
                  t.mute.set($(this).hasClass(sc('sound-off')));
                
                  if (ref.visitor)
                      ref.visitor.child('mute').set(t.mute.value);
                
                });
                
                ui.box.on('click', sc('#show-endchat-confirmation'), function ()
                {
                    show_rating()
                });
                
                ui.modal.on('click', sc('.modal-close-action'), function ()
                {
                  if (ui.rating) ui.rating.unload()
                  ui.modal.addClass(hide);
                  ui.message_box.removeClass(hide);
                });
                
                

                ui.box.on('click', sc('.start-new'), function(e) {
                    e.preventDefault();
                    if (!session) return;
                    start_new_chat();
                });
                
                ui.box.on('click', sc('.save-trascript'), function(e) {
                    e.preventDefault();
                    var email = (meta && meta.email) ? meta.email : '';
                    ui.modal.html(render(templates.transcript, $.extend(def_lang,{
                        email: email
                    })));
                });
                
                ui.box.on('click', sc('#close-transcript'), function(e) {
                    e.preventDefault();
                    show_end_chat();
                });
                
                ui.box.on('submit', sc('#form-transcript'), function(e) {
                
                    e.preventDefault();
                    var o = $('input[name=email]', this);
                
                    if (!o.val()
                        .trim())
                        return o.addClass(sc('error'));
                
                    var email = o.val()
                        .split(',');
                    var m = {};
                
                    for (var i = 0; i < email.length; i++) {
                
                        email[i] = $.trim(email[i]);
                
                        if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email[i]) == false) {
                            o.addClass(sc('error'));
                            return;
                        }
                
                        m[i] = email[i];
                    }
                
                    $(sc('.button-transcript'), this)
                        .val('Please wait ...')
                        .attr('disabled', 'disabled');
                
                    request_transcript(m);
                
                    o.val('');
                
                });
                
                function request_transcript(email) {
                    var v = '';
                    for (var i in email) {
                        if (v != '') v += ', ';
                        v += email[i];
                    }
                
                    $.ajax({
                        url: api + '/transcript/send/visitor',
                        type: 'POST',
                        data: {
                            organization_id: org_id,
                            email: email,
                            visitor_id: t.uid.value,
                            session_id: t.sid.value,
                        },
                        error: function(response) {
                
                            $(sc('.button-transcript'), ui.box)
                                .val(t.widget.value.language.send)
                                .removeAttr('disabled');
                
                            $(sc('#form-transcript-error'), ui.box)
                                .removeClass(hide);
                            $(sc('#form-transcript-error') + ' span', ui.box)
                                .html(v);
                
                        },
                        success: function(response) {
                
                            $(sc('.button-transcript'), ui.box)
                                .val(t.widget.value.language.send)
                                .removeAttr('disabled');
                
                            $(sc('#form-transcript-success'), ui.box)
                                .removeClass(hide);
                            $(sc('#form-transcript-success') + ' span', ui.box)
                                .html(v);
                
                        },
                    });
                }
                
                function do_index(type) {
                
                    var data = {
                        organization_id: org_id,
                        session_id: t.sid.value,
                        event_type: type,
                        message_id: null,
                    }
                
                    $.ajax({
                        type: "POST",
                        url: api + "/indexer",
                        data: data,
                    })
                
                }
                

                ui.box.on('click', sc('.chathead, .minimize-wrapper, #bubble-head'),
                  function (e) {
                
                    if (isPopOut) {
                      return;
                    }
                
                    if (!ref.visitor) {
                      pop_message({ message: "I'm still loading, please wait ..." });
                      return;
                    }
                
                    e.preventDefault();
                    if (!t.minimize.value) {
                      ref.visitor.child('window_minimize').set(true);
                    } else {
                      ref.visitor.child('window_minimize').set(false);
                      if (t.view_state.value == 1 && online() && do_prechat() == false) {
                        request_chat();
                      }
                    }
                  }
                );
                
                $(sc('.icons') + ' li', ui.box)
                  .on('mouseenter', function () {
                    $(this).addClass(sc('icons-hover'));
                  })
                  .on('mouseleave', function () {
                    $(this).removeClass(sc('icons-hover'));
                  });
                
                $(sc('.popout-wrapper'), ui.box).on('click', function (e) {
                  if (t.minimize.value) {
                    ref.visitor.child('hidden').set(fb_time);
                    return true;
                  }
                
                  popout();
                });
                
                $(window).on('message', function (e) {
                
                  var evt = e.originalEvent;
                  if (evt.origin.indexOf('swaychat.com') > -1 && evt.data)
                       {
                
                      if (!evt.data
                            || typeof evt.data != 'string'
                            || /swaychat_popout/.test(evt.data) == false
                            ) return;
                
                    var data = JSON.parse(evt.data);
                
                    //console.log(data)
                    if (data.popout)
                                        switch (data.popout)
                                            {
                                          case 'popout_success':
                                            clearTimeout(pop_timer);
                                            ui.box.addClass(hide);
                                            break;
                                          case 'popout_close':
                                            pop_failed();
                                            break;
                                        }
                  }
                
                });
                
                if (isPopOut && opener && (!ie || ie > 9))
                {
                  opener.postMessage(JSON.stringify({ popout:'popout_success', swaychat_popout: true }), '*');
                
                  $(window).on('beforeunload', function () {
                    if (!chat)
                        opener.postMessage(JSON.stringify({ popout:'popout_close', swaychat_popout: true }), '*');
                  });
                
                }
                

                (function() {
                
                    function valid_name(name) {
                        if (/^[\u0000-\u007f]*$/.test(name) === true)
                          return /^[a-zA-Z\s]*$/.test(name);
                
                        return true;
                    }
                
                    function valid_email(email) {
                        return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
                    }
                
                    function valid_phone(phone) {
                        return (/^\d+$/.test(phone) && phone.length > 6);
                    }
                
                    function detectIE() {
                
                        // Source: http://codepen.io/gapcode/pen/vEJNZN
                
                        var ua = window.navigator.userAgent;
                
                        var msie = ua.indexOf('MSIE ');
                        if (msie > 0) {
                            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
                        }
                
                        var trident = ua.indexOf('Trident/');
                        if (trident > 0) {
                            var rv = ua.indexOf('rv:');
                            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                        }
                
                        var edge = ua.indexOf('Edge/');
                        if (edge > 0) {
                            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
                        }
                
                        return false;
                
                    }
                
                    function send_message(email, message) {
                
                        if ((!online() && t.widget.value.options.destination == true)
                            || (online() && t.widget.value.options.online_form.notify_by_email)) {
                
                            var off_meta = {};
                
                            off_meta.url = location.href;
                
                            if (meta.phone)
                                off_meta.phone = meta.phone;
                
                            if (document.referrer)
                                off_meta.referrer = document.referrer;
                
                            $.ajax({
                                url: api + '/offline_message',
                                type: 'POST',
                                data: {
                                    organization_id: org_id,
                                    visitor_id: t.uid.value,
                                    session_id: t.sid.value,
                                    widget_id: widget_id,
                                    email: email,
                                    name: meta.name ? meta.name : email,
                                    meta: off_meta,
                                    message: message
                                }
                            })
                
                        }
                
                    }
                
                    var helpers = {
                
                        context: {
                            socialPopup: null,
                            socialIframe: null,
                            ie: detectIE()
                        },
                
                        message_success: function(o, s) {
                
                            t.network.set(o.network);
                            meta.name = (o.network === 'facebook' && o.name) ? o.name : o.first_name + ' ' + o.last_name;
                            meta.email = o.email;
                            meta.src = s.social;
                            meta.avatar = o.thumbnail;
                            meta[s.social] = o;
                            update_form();
                
                        },
                
                        message_reset: function(o, s) {
                
                            t.network.set('');
                            meta = {
                                assigned: meta.assigned
                            };
                            update_form();
                
                        },
                
                        pop_window: function(url, title, w, h) {
                
                            var left = (screen.width / 2) - (w / 2),
                                top = (screen.height / 2) - (h / 2),
                                parameters = 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no,width=' + w + ',height=' + h,
                                child = window.open(url, title, parameters);
                
                            return child;
                
                        },
                
                        embed_iframe: function(url) {
                
                            var iframe = $('<iframe/>')[0];
                            iframe.src = url;
                            $(iframe).css('visibility', 'hidden');
                            $('body').append(iframe);
                
                            return iframe;
                
                        },
                
                        close_child: function() {
                
                            if (helpers.context.ie) {
                                $(helpers.context.socialIframe).remove();
                                helpers.context.socialIframe = null;
                                if ('activeElement' in document) {
                                    document.activeElement.blur();
                                }
                            } else {
                                helpers.context.socialPopup.close();
                                helpers.context.socialPopup = null;
                            }
                
                        }
                
                    };
                
                    this.prechat = this.prechat || {
                
                        handlers: {
                
                            telephone: function(e) {
                
                                var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
                                var ch = '0123456789-+';
                
                                if (!e.ctrlKey && ch.indexOf(key) < 0)
                                    e.preventDefault();
                
                            },
                
                            form_enter: function(e) {
                                    if (e.which == 13 && online()) {
                                        e.preventDefault();
                                        if ($.trim($(this).val()))
                                            $(this).parents('form').trigger('submit');
                                    }
                            },
                
                            form_submit: function(e) {
                
                                e.preventDefault();
                
                                if (!session || (session && !session.teams) || session.state > 1) {
                
                                    var btn = $(sc('.button'), this);
                                    btn.text('Not ready, please wait ...');
                                    setTimeout(function() {
                                        btn.text(t.widget.value.language.send)
                                    }, 2000);
                
                                    return;
                                }
                
                                if (do_prechat() == false) {
                                    return request_chat();
                                }
                
                                var data = $(this).serializeArray();
                                var form = {};
                                var form_error = false;
                
                                if (!t.sid.value) return;
                
                                var err = sc('error');
                
                                $('.' + err, ui.box).removeClass(err);
                
                                for (var i in data) {
                                    var k = data[i].name;
                                    if (!k) continue;
                                    var o = $('[name=' + k + ']', this);
                
                                    form[k] = o.val().trim();
                
                                    if (!o.val() && o.data('required')) {
                                        o.addClass(err);
                                        form_error = true;
                                    }
                
                                    if (o.val() && o.attr('type') == 'text' && valid_name(o.val()) == false) {
                                        o.addClass(err);
                                        form_error = true;
                                    }
                
                                    if (o.val() && o.attr('type') == 'tel' && valid_phone(o.val()) == false ) {
                                        o.addClass(err);
                                        form_error = true;
                                    }
                
                                    if (o.val() && o.attr('type') == 'email' && valid_email(o.val()) == false) {
                                        o.addClass(err);
                                        form_error = true;
                                    }
                
                                }
                
                                if (form_error) {
                                    $('.' + err + ':first', ui.box).trigger('focus');
                                    return;
                                }
                
                                var fn = form.name ? form.name : '';
                                ref.session.child('meta/name').set(fn);
                
                                var fe = form.email ? form.email : '';
                                ref.session.child('meta/email').set(fe);
                
                                if (form.phone) {
                                    ref.session.child('meta/phone').set(form.phone);
                                }
                
                                if (form.email) {
                                    if (meta.src && meta.avatar)
                                        ref.session.child('meta/avatar').set(meta.avatar);
                                    else {
                                        var g = md5(form.email);
                                        ref.session.child('meta/avatar').set('//www.gravatar.com/avatar/' + g);
                                    }
                                } else
                                    ref.visitor.child('meta/avatar').remove();
                
                                if (t.teams.value)
                                    for (var n in t.teams.value) {
                                        ref.session.child('teams').child(n).child('role').set(0);
                                    }
                
                                if (meta.src) {
                                    ref.session.child('meta').child('src').set(meta.src);
                                    ref.session.child('meta').child(meta.src).set(meta[meta.src]);
                                }
                
                                if (form.departments && form.departments != '') {
                                    team = form.departments;
                                    ref.session.child('team').set(form.departments);
                                    ref.session.child('teams').child(form.departments).child('role').set(1);
                                }
                
                                if (form.message) {
                
                                    push_message({
                                        message: form.message,
                                        subtype: 1
                                    });
                
                                    if (!online())
                                        ref.session.child('sent_offline').set(true);
                
                                    if (form.email)
                                        send_message(form.email, form.message)
                
                                    $('[name=message]', this).val('');
                                }
                
                                if (online())
                                    request_chat();
                                else {
                                    ref.session.child('state').set(2);
                                    t.sent_offline.set(1)
                                    if (t.widget.value.options.offline_form.endchat)
                                        do_end();
                                    else
                                        request_chat();
                                }
                
                            },
                
                            login: function(e) {
                
                                var network = $(this).data('target'),
                                    url = cdn + 'html/social.html?network=' + network + '&action=login';
                
                                if (helpers.context.ie) {
                                    if(helpers.context.socialIframe) {
                                        $(helpers.context.socialIframe).remove();
                                    }
                                    helpers.context.socialIframe = helpers.embed_iframe(url);
                                } else {
                                    helpers.context.socialPopup =
                                        (helpers.context.socialPopup && !helpers.context.socialPopup.closed)
                                            ? helpers.context.socialPopup
                                            : helpers.pop_window(url, '', 1000, 600);
                                }
                
                            },
                
                            logout: function(e) {
                
                                e.preventDefault();
                                $(this).blur();
                
                                var network = $(this).data('target'),
                                    url = cdn + 'html/social.html?network=' + network + '&action=logout';
                
                                if (helpers.context.ie) {
                                    helpers.context.socialIframe = helpers.context.socialIframe || helpers.embed_iframe(url);
                                } else {
                                    helpers.context.socialPopup =
                                        (helpers.context.socialPopup && !helpers.context.socialPopup.closed)
                                            ? helpers.context.socialPopup
                                            : helpers.pop_window(url, '', 1000, 600);
                                }
                
                                ref.session.child('meta')
                                    .child('src')
                                    .remove();
                                ref.session.child('meta')
                                    .child(t.network.value)
                                    .remove();
                                meta = {
                                    assigned: meta.assigned
                                };
                                t.network.set('');
                                update_form();
                
                            },
                
                            meta_placeholder_update: function() {
                                if (hasPlaceholder() || $(this).val() != $(this).attr('placeholder'))
                                    meta[this.name] = this.value;
                            },
                
                            message: function(e) {
                
                                var evt = e.originalEvent;
                
                                if (!(evt.origin.indexOf('swaychat.com') > -1 && evt.data))
                                    return;
                
                                if (typeof evt.data == 'object') return;
                
                                var s = JSON.parse(evt.data);
                
                                if (!s.social)
                                    return;
                
                                var o = s.data;
                
                                switch (s.social) {
                
                                    case 'login':
                                        helpers.close_child();
                                        helpers.message_success(o, s);
                                        break;
                
                                    case 'logout':
                                        helpers.close_child();
                                        helpers.message_reset(o, s);
                                        break;
                
                                }
                
                
                            },
                
                            initialize_native_placeholder_support: function() {
                
                                ui.prechat.on('focus', 'input, textarea', function() {
                                    if ($(this).val() == $(this).attr('placeholder'))
                                        $(this).val('');
                                });
                
                                ui.prechat.on('blur', 'input, textarea', function() {
                                    if ($(this).val() == '')
                                        $(this).val($(this).attr('placeholder'));
                                });
                
                            }
                
                        },
                
                        initialize: function() {
                
                            if (this.isInitialized)
                                return;
                
                            ui.prechat.on('keypress', 'input[type=tel]', this.handlers.telephone);
                            ui.prechat.on('submit', 'form', this.handlers.form_submit);
                            ui.prechat.on('keypress','textarea', this.handlers.form_enter);
                            ui.box.on('click tap', sc('.social-icons') + ' li', this.handlers.login);
                            ui.box.on('click tap', sc('.social-h5-signed') + ' a', this.handlers.logout);
                            ui.prechat.on('change', 'input, textarea, select', this.handlers.meta_placeholder_update);
                            $(window).on('message', this.handlers.message);
                            if (!hasPlaceholder()) {
                                this.handlers.initialize_native_placeholder_support();
                            }
                
                            this.isInitialized = true;
                        },
                
                        isInitialized: false
                
                    }
                
                }());
                
                this.prechat.initialize();
                


                if (bound_ui) return true;

                bound_ui = true;

                ui.lightbox.on('click', function(e) {
                    $(this).addClass(hide);
                });

                $(document).keyup(function(e) {
                    if (e.keyCode == 27 && !ui.lightbox.hasClass(hide)) ui.lightbox.trigger('click');
                });

                $(window).on('resize', function(e) {

                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(function() {

                        // Run code here, resizing has "stopped"
                        wh = $(window).height();
                        do_height()

                    }, 250);

                });

                $('.SwayChat-Popout, .SwayChat-Toggle').show()

                if (window.watch)
                window.watch('swaychat_api', function(id, oldv, newv) {
                    if (typeof newv == 'function' && newv.toString().match('swaychat.set_'))
                        newv();
                })

                // Bugsnag.leaveBreadcrumb('Bound UI');

            }

            function load_state() {

                var v = t.view_state.value;

                if (!v || !ui.box) return;

                //reset visible elements
                $(sc('.module'), ui.box).addClass(hide);
                ui.box.removeClass(sc('pre-chat'));

                if (v == 1) {
                    show_header('prechat');
                    ui.box.addClass(sc('pre-chat'));
                    if (m_state === false && t.minimize.value === false) {
                        ui.container.height(ui.container.height())
                        do_height()
                    }

                    ui.prechat_box.removeClass(hide);
                }

                if (v == 2) {
                    show_header('prechat');
                    ui.container.height('');
                    ui.conversation.removeClass(hide);
                    ui.message_box.removeClass(hide);
                }

                if (v == 3) {
                    show_header('agent');
                    ui.conversation.removeClass(hide);
                    ui.message_box.removeClass(hide);
                }

                if (v == 4) {
                    if (lastnotify && lastnotify.unload) lastnotify.unload();
                    show_header('prechat');
                    ui.modal.removeClass(hide);

                    if (!t.rate.get() && !t.sent_offline.get() && t.widget.value.settings.rating)
                        show_rating();
                    else
                        show_end_chat();

                    $(sc('.modal-close-action')).addClass(hide);

                }

                if (isPopOut) {
                    set_minimize();
                    if (!t.popout.get()) t.popout.set(true);
                    $(sc('.icons'), ui.box).addClass(hide);
                    ui.box.addClass(sc('popout'));
                } else if (t.popout.value)
                    ui.box.addClass(hide);

                if (!is_loaded) {
                    is_loaded = true;
                    ui.box.removeAttr('style');

                    $(sc('.toggle-hide')).removeClass(sc('toggle-hide'))

                    if (!t.minimize.value) {
                        ui.container.addClass(sc('maximize-window fadeIn'));

                        setTimeout(function() {
                            ui.container.removeClass(sc('fadeIn'));
                        }, 500);

                    }

                }
            }

            function show_header(type) {
                ui.box.find(sc('#' + type + '-header'))
                    .show()
                    .siblings().hide();

                $('div', ui.bubblehead).html(ui.box.find(sc('#' + type + '-header .chathead-img')).html());

            }

            function changeHost (url) {
              return url && url.includes('www.ucarecdn.com')
                ? url.replace('www.ucarecdn.com', 'files.swaychat.com')
                : url;
            }

            function update_header(type) {

                if (!ui.box) return;
                if (!t.widget.value) return;

                var el = $(sc('#' + type + '-header'), ui.box);
                var data = {};
                var src;
                var old_src = el.find('img').attr('src');

                if (type == 'prechat') {
                    var o = t.widget.value.options[(online() ? 'online' : 'offline') + '_form'].labels;
                    var df = t.widget.value.theme.default_img;
                    src = cdn + "img/sc-header-icon-default-" + df + ".png";
                    if (typeof df == 'string')
                        src = df;

                    data.form_title = o.form_title;
                    data.form_title_sub = o.form_title_sub;
                }

                if (type == 'agent') {

                    var v = t.agent.get()

                    if (!v) return;

                    var k = v.key;

                    data = {
                        form_title: v.name,
                        form_title_sub: v.title,
                        initial: v.name.substring(0, 1),
                        bg: getuidcolor(k),
                    }

                    src = v.avatar ? v.avatar : '';

                }

                $(sc('#' + type + '-header .chathead-ini'), ui.box).html(render(templates.agent_ini, data))

                el.find(sc('.agent-details'))
                    .html(render(templates.agent_details, data));

                if (src != old_src) {
                    if ((type == 'agent' && t.view_state.value == 3) || (type == 'prechat' && t.view_state.value != 3))
                        ui.box.find(sc('#bubble-head .chathead-src')).html(render(templates.bounce_img, {
                            src: changeHost(src)
                        }));

                    if (type == 'prechat')
                        ui.box.find(sc('#prechat-header .chathead-src')).html(render(templates.bounce_img, {
                            src: changeHost(src)
                        }));
                    else
                        ui.box.find(sc('#agent-header .chathead-src')).html(render(templates.bounce_img, {
                            src: changeHost(src)
                        }));
                }
            }

            var nh;

            function update_form() {

                if (!ui.prechat) return;
                if (!t.widget.value) return;

                var el = ui.prechat;
                var type = online() ? 'online' : 'offline';
                var widget = t.widget.value;

                //do not disturb if any of the form has focus

                if ($(':focus', el).length)
                    return;

                var form = widget.options[type + '_form'];
                var o = {};

                $.extend(o, widget.language);
                $.extend(o, form.labels);
                o.type = type;
                o.form_items = '';
                o.form_submit = '';

                var order = form.order;

                if (do_prechat()) {

                    for (var i = 0; i < order.length; i++) {
                        var field = form.fields[order[i]];

                        if (!field.visible) continue;

                        if (field.placeholder)
                            field.label = field.placeholder;

                        field.value = (!hasPlaceholder()) ? field.label : '';

                        if (field.name == 'departments' && t.teams.value) {
                            field.form_options = '';
                            for (var j in widget.teams)
                                if (widget.teams[j] && t.teams.value[j])
                                    field.form_options += render(templates.form_options, {
                                        value: j,
                                        label: t.teams.value[j].name
                                    });

                        }

                        if (field.name == 'social') {

                            field.form_options = '';
                            field.signs = '';

                            field.signed = t.network.value ? sc('social-signed-in') : '';
                            field.social = t.network.value ? sc('social-signed-in-') + t.network.value : '';

                            for (var j in field.options)
                                if (field.options[j] && (field.options[j].visible || field.options[j].class == t.network.value)) {
                                    field.signs += render(templates.form_social_signed, field.options[j]);
                                    field.form_options += render(templates.form_social_option, field.options[j]);
                                }
                        }

                        if (!field.form_options && field.template === "select")
                            field.visible = false;

                        o.form_items += render(templates['form_' + field.template], field);
                    }

                    o.form_submit = render(templates.form_submit, o);

                }

                var data = $('form', el).serializeArray();

                el.html(render(templates.preform, o));

                if (meta)
                    for (var k in meta)
                        $('[name=' + k + ']', ui.prechat).val(meta[k]);

                if (m_state === false)
                    do_height()

            }

            function load_social() {
                social = $('<iframe />').get(0);
                social.style.display = 'none';
                social.src = cdn + 'html/social.html';
                document.body.appendChild(social);
            }

            function request_chat() {

                ref.visitor.child('window_minimize').set(false);
                ref.session.child('view_state').set(2);
                ref.session.child('state').set(2);
                t.state.set(2)

                var n = (meta && meta.name ? meta.name : '');
                var msg = render(t.widget.value.options[(online() ? 'online' : 'offline') + '_form'].labels.message_received, {
                    name: n
                });

                push_message({
                    from: org_id,
                    message: msg,
                    type: 3,
                    subtype: 0,
                }, true);

            }

            function push_message(o) {
                var data = {
                    from: t.uid.value,
                    status: false,
                    type: 0,
                    subtype: 1,
                    created_at: fb_time,
                    updated_at: fb_time,
                };
                var newMessage = false;

                var ref_messages = fb.child('messages').child(t.sid.value)
                var rcvr = session.agent ? session.agent : session.team ? session.team : org_id;

                if (!session.queued_at) {
                    // Queued and Report
                    newMessage = true;
                    session.queued_at = new Date().getTime();

                    ref.session.child('queued_at').set(fb_time);

                    var q = $.extend({}, data);
                    q.type = 1;
                    q.subtype = 1;
                    ref_messages.child('data').push(q);

                    fb.child('roundrobin').once('value').then(function(snap) {
                        if (!(snap.val() && online())) {
                            _NotifyService.notify({
                                code: 2,
                                receiver: rcvr
                            });
                        } else if (snap.val() && online()) {
                            _RoundRobin.push({
                                created: fb_time,
                                org_id: org_id,
                                sid: t.sid.get(),
                                team: session.team ? session.team : false,
                                teams: session.teams,
                            })
                        }
                    });
                }

                if (typeof o === 'object')
                    $.extend(data, o);
                else
                    data.message = o;

                if (data.message)
                    data.message = data.message
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')


                var msg = ref_messages.child('data').push(data);

                ref.session.child('updated_at').set(fb_time);
                ref.lobby.child('updated_at').set(fb_time);

                if (data.type == 0 && data.from == t.uid.value) {

                    //automatically read our message
                    ref_messages
                        .child('read').child(t.uid.value)
                        .transaction(function(c) {
                            return c + 1
                        });

                    //update unread count
                    ref_messages
                        .child('visitor_msg_count')
                        .transaction(function(c) {
                            if (c > 0)
                                _NotifyService.notify({
                                    receiver: rcvr
                                });
                            return c + 1
                        });
                }

                // if org has add ons, save in queue
                if (hasIntegrations) {
                    var i = {
                        org_id: org_id,
                        sid: ref_messages.key(),
                        did: msg.key()
                    };

                    if (newMessage) i.new = true;
                    if (+data.type === 1) {
                        if (+data.subtype === 0) {
                            i.type = 'visitor_left';
                        } else if (+data.subtype === 7 || +data.subtype === 11) {
                            i.type = 'rate';
                        } else if (+data.subtype === 8) {
                            i.type = 'comment';
                        }
                    }

                    if (
                        data.type === 0
                        || i.new
                        || i.type
                    ) {
                        _Integrations.push(i);
                    }

                }

                return msg.key();

            }

            function visitor_session_handler(nv) {

                // Bugsnag.leaveBreadcrumb("New session received")

                t.sid.set(nv.data.session_id);

                var o = {
                    session_id: nv.data.session_id,
                    updated_at: fb_time,
                }

                ref.visitor.update(o);
                ref.visitor.child('sessions').child(t.sid.value).set(fb_time)
                $.extend(visitor, o);

            }

            function start_new_chat() {

                // Bugsnag.leaveBreadcrumb("Request new chat")

                if (do_prechat() || !online())
                    ref.session.child('view_state').set(1)
                else
                    ref.session.child('load_state').set(true)

                t.sent_offline.set(0);

                var data = {
                    organization_id: org_id,
                    widget_id: widget_id,
                    uid: t.uid.value,
                }

                $.ajax({
                        type: "POST",
                        url: api + "/visitor/session",
                        data: data,
                        dataType: 'jsonp',
                        //                timeout: 1000*60*2,
                    })
                    .done(visitor_session_handler)
                    .fail(function(xhr, textStatus, errorThrown) {

                        //ignore aborted request and try again after 60 secs
                        if (xhr.status === 0 || xhr.readyState === 0) {
                            retry_delay = 1000 * 60 * 2;
                            // Bugsnag.leaveBreadcrumb('Session Request Aborted')
                        } else {

                            // Bugsnag.leaveBreadcrumb('API Session Failed')

                            // Bugsnag.notify('API Session Failed', 'Failed Session v1', {
                            //     error: {
                            //         status: textStatus,
                            //         error: errorThrown,
                            //         headers: xhr.getAllResponseHeaders ? xhr.getAllResponseHeaders() : '',
                            //         content: xhr.responseText,
                            //         data: data,
                            //     }
                            // })

                        }

                        setTimeout(start_new_chat, retry_delay)

                    })
                    .then(bind_ref_session)
                    .then(bind_ref_messages)
                    .then(bind_ref_history)
                    .done(function() {

                        if (!do_prechat() && online())
                            request_chat();

                    });


            }

            function do_end() {

                if (ui.rating)
                    ui.rating.unload()

                push_message({
                    type: 1,
                    subtype: 0,
                });

                ref.session.child('left_at').set(Firebase.ServerValue.TIMESTAMP);
                ref.session.child('visitor_status').set('away');

                if (t.view_state.get() == 4) {
                    show_end_chat()
                } else {
                    ref.session.child('view_state').set(4);
                }
            }

            function show_rating() {

                //temp solution until objectify other modules
                ui.modal.empty()

                if (t.widget.value.settings.rating == 1 || t.widget.value.settings.rating === true)
                    ui.rating = new Simple_Rating()
                else if (t.widget.value.settings.rating == 2) {
                    if (t.widget.value.settings.advance_rating)
                        ui.rating = new Advance_Rating()
                    else
                        ui.rating = new Simple_Rating()
                } else
                    ui.rating = new No_Rating()

                ui.rating.load()
                ui.modal.removeClass(hide)
                ui.message_box.addClass(hide);

            }

            function show_end_chat() {

                var data = {
                    no_transcript: t.widget.value.settings.transcript ? '' : 'style="display:none"'
                };
                var rate = t.rate.get();
                var widget = t.widget.value;

                $.extend(data, widget.language);

                if (rate != null && rate != 0 && t.widget.value.settings.rating == 1) {

                    var rtype = {
                        '-1': {
                            class: 'notgood',
                            response: data.sorry
                        },
                        1: {
                            class: 'ok',
                            response: data.sorry
                        },
                        2: {
                            class: 'great',
                            response: data.thank_you
                        },
                    };

                    $.extend(data, rtype[rate]);
                    data.rated = render(data.rated, {
                        rating: data.ratings[rate].label
                    });
                    data.rates = render(templates.rated, data);

                } else {

                    data.class = 'great';
                    data.response = data.thank_you;
                    data.rated = '';
                    data.rates = render(templates.rated, data);

                }

                ui.modal.empty().append(render(templates.end_chat, data));
            }

            //end of App, return public methods

            function toggle() {
                if (!t.sid || !t.sid.get()) return;
                $(sc('#minimize')).trigger('click');
            }

            function popout() {

                if (!t.sid || !t.sid.get()) return;
                if (isPopOut || t.popout.get()) return;

                var u = cdn + 'html/chat.html?org=' + org_id + '&widget=' + widget_id;

                u += p.cdn ? '&cdn=' + p.cdn : '';
                u += p.fb ? '&fb=' + p.fb : '';
                u += p.api ? '&api=' + p.api : '';

                pop_window(u, 'swaychat', 320, 480);

                if (ui && ui.box)
                    ui.box.addClass(hide);

                pop_timer = setTimeout(pop_failed, 10000);

            }

            function pop_window(url, title, w, h) {

                var left = (screen.width / 2) - (w / 2);
                var top = (screen.height / 2) - (h / 2);
                var pop;

                pop = window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

                if (pop) pop.focus();

                return pop;

            }

            function pop_failed() {
                if (!t.popout.get())
                    $(ui.box).removeClass(hide);
            }

            function set_field(field, value) {

                var task = $.Deferred();
                var data = {}
                var allow = ['name', 'email', 'phone']

                if (typeof field == 'object')
                    $.extend(data, field)
                else
                    data[field] = value;

                //            console.log(data,field,value, allow.indexOf(field))


                for (var i in data)
                    if (allow.indexOf(i) < 0 || $.trim(data[i]) == '')
                        delete data[i]

                if (data.email && !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(data.email)) {
                    return task.fail()
                }

                if (data.email) {
                    var g = md5(data.email);
                    data.avatar = '//www.gravatar.com/avatar/' + g;

                }

                if (data.phone && !/^[0-9-]*$/.test(data.phone)) {
                    return task.fail()
                }

                if (data.name && !/^[a-zA-Z .]*$/.test(data.name)) {
                    return task.fail()
                }

                if (data.name)
                    data.name = data.name.swaychat_capitalize()

                for (var i in data)
                    ref.session.child('meta').child(i).set(data[i], function() {
                        task.resolve()
                    })

                return task.promise();
            }

            function getSession() {
                return t.sid.get();
            }

            return {
                toggle: toggle,
                popout: popout,
                load: bind,
                set_field: set_field,
            }

        } catch (e) {
            // Bugsnag.notifyException(e);
        }
    } //end of app

    var app = new App();
    app.load()

    $.extend(swaychat, app);

})(document, swaychat, swaychat.$, swaychat.Fb);
